import Header from "../navigation/header";
import {
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Switch,
  Modal,
  TextInput,
  Pressable,
  FlatList,
  Alert,
  ListRenderItemInfo,
  ActivityIndicator,
  Platform,
  Keyboard,
  Dimensions,
} from "react-native";
import CryptoJS from "react-native-crypto-js";

import { TimePickerModal } from "react-native-paper-dates";

import SuccessPopup from "../../components/SuccessPopup";

import { RadioButton, Button } from "react-native-paper";
import { SwiperFlatList } from "react-native-swiper-flatlist";
import {
  MenuProvider,
  MenuContext,
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
} from "react-native-popup-menu";
import { DatePickerModal } from "react-native-paper-dates";
import moment from "moment";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Dropdown } from "react-native-element-dropdown";
import MultiSelect from "react-native-multiple-select";
import IconRefresh from "react-native-vector-icons/FontAwesome";

import { Text, View } from "../../components/Themed";
import { jsonToCSV } from "react-native-csv";
import { RootStackScreenProps } from "../../types"; 
import React, { useEffect, useState, useRef } from "react";
import Icon from "react-native-vector-icons/FontAwesome";
import IconPlusMinus from "react-native-vector-icons/AntDesign";
import IconArrow from "react-native-vector-icons/Entypo";

import DataTable from "react-data-table-component";
import IconTimer from "react-native-vector-icons/Entypo";
import IconSelect from "react-native-vector-icons/AntDesign";

import { useFocusEffect } from "@react-navigation/native";
import { postData, baseUrlSocket } from "../../networking/api";
import { Provider as PaperProvider } from "react-native-paper";
import IconEdit from "react-native-vector-icons/FontAwesome";
import IconCross from "react-native-vector-icons/Entypo";

import IconEye from "react-native-vector-icons/Entypo";
import { color } from "react-native-elements/dist/helpers";
import Swiper from "react-native-web-swiper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

import { useSelector, useDispatch } from "react-redux";
import socketServices from "../../constants/utils/socketService";
import { err } from "react-native-svg/lib/typescript/xml";
import crypto from "crypto";
import { enableLegacyWebImplementation } from "react-native-gesture-handler";

export default function ScheduleProgram({ navigation }) {
  var dispatch = useDispatch();
  const styles = useStyles();

  var idProject = useSelector((state) => state.idUpdating);

  const [text, setText] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isCreateProgSuccessVisible, setisCreateProgSuccessVisible] =
    useState(false);
  const [isProgramLimit, setIsProgramLimit] = useState(false);
  const [ProgramLimitError, setProgramLimitError] = useState("");

  const [updatedata, setupdatedata] = useState(false);
  const [ValveIsVisible, setValveIsVisible] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [isAdd, setisAdd] = useState(false);
  const [programIndex, setProgramIndex] = useState(0);

  const [programsId, setProgramsId] = useState();
  const [BermadProgramsId, setBermadProgramId] = useState("");
  const [socketDetails, setSocketDetails] = useState([]);
  const [UpdateProgramIndex, setUpdateProgramIndex] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSync, setIsLoadingSync] = useState(false);
  const [Omegaerror, setOmegaaError] = useState("");

  const [ScheduleProgramDataLength, setScheduleProgramDataLength] = useState(0);
  const [ScheduleProgramNameData, setScheduleProgramNameData] = useState([]);
  const [projectId, setProjectId] = useState("");

  const [issuccessVisible, setissuccessVisible] = useState(false);
  const [responsestatus, setresponsestatus] = useState("");
  const [PopupMessage, setPopupMessage] = useState("");
  const [OmegaIdData, setOmegaIdData] = useState([]);
  const [deviceNameData, setDeviceNameData] = useState([]);
  const [isProgStart, setIsProgStart] = useState(false);

  const [shouldShow, setShouldShow] = useState(true);
  const [breckloop, setbreckloop] = useState(false);
  const [OmegaDetails, setOmegaDetails] = useState([]);
  const [ProgramAmountDetails, setProgramAmountDetails] = useState([]);
  const [refreshflatlist, setrefreshflatlist] = useState(false);
  const [valveDetails, setValveDetails] = useState([]);
  const [valveArr, setValveArr] = useState([]);
  const [sensorTypeDetails, setSensorTypeDetails] = useState([]);
  const [selectedValve, setSelectedValve] = useState();
  const [ValveSelected, setValveSelected] = useState({});
  const [newProjectName, setProjectName] = useState("");
  const [SensorvalueType, setSensorvalueType] = useState("");
  const [sensorStatusId, setSensorStatusiD] = useState("");
  const [sensorStatusIdValue, setSensorStatusIdValue] = useState(null);
  const [indexforconfirmstarttime, setindexforconfirmstarttime] =
    useState(null); 
  const [indexforvalve, setIndexValve] = useState(0);
  const [selectedValveItems, setSelectedValveItems] = useState([]);

  const [progNameError, setprogNameError] = useState("");
  const [programTypeError, setprogramTypeError] = useState("");

  const [progDaysError, setProgDaysError] = useState("");
  const [programTimeError, setprogramTimeError] = useState("");

  const [programStrtTimeError, setprogramStrtTimeError] = useState("");
  const [programEndTimeError, setprogramEndTimeError] = useState("");
  const [programHoursError, setprogramHoursError] = useState("");

  const [AddValveError, setAddValveError] = useState("");
  const [progActionError, setprogActionError] = useState("");

  const [deviceError, setDeviceError] = useState("");
  const [StatusError, setStatusError] = useState("");
  const [valveError, setValveError] = useState("");

  const flatListRef = useRef(FlatList);
  var finaldata: {
    amount: any;
    name: any;
    order: number;
    valve: { connect: { id: any } };
  }[] = [];

  setIndexValve;
  const [sensorStatus, setSensorStatus] = useState([
    {
      id: 1,
      name: "Open",
    },
    {
      id: 2,
      name: "Close",
    },
  ]);

  const [mainindexmodal, setmainindexmodal] = useState("");

  const [OmegaAddvalueId, setOmegaAddValueiD] = useState("");
  const [omegaNewid, setomegaNewid] = useState("");
  const [OmegaAddIdValue, setOmegaAddIdValue] = useState(null);
  const [OmegaIdName, setOmegaIdName] = useState(null);
  const [defaultOmegaId, setDefaultOmegaId] = useState("");
  const [defaultOmegavalueId, setdefaultOmegaValueiD] = useState("");

  const [OmegaIdValue, setOmegaIdValue] = useState(null);
  const [OmegavalueId, setOmegaValueiD] = useState("");

  const [DeviceNameIdValue, setDeviceNameIdValue] = useState(null);
  const [DeviceNamevalueId, setDeviceNameValueiD] = useState("");

  const [omegaid, setomegaid] = useState("");
  const [OmegaError, setOmegaError] = useState("");
  const [isopen, setisopen] = useState(false);
  const [programAmount, setprogramAmount] = useState([]);
  const [measurementType, setmeasurementType] = useState("");

  const [SensorvalueId, setSensorValueiD] = useState("");
  const [SensorIdValue, setSensorIdValue] = useState(null);

  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedDaysId, setSelectedDaysId] = useState([]);
  const [binaryToDecimal, setBinaryToDecimal] = useState();

  const [AddselectedDays, setAddSelectedDays] = useState([]);
  const [AddselectedDaysId, setAddSelectedDaysId] = useState([]);
  const [AddbinaryToDecimal, setAddBinaryToDecimal] = useState();

  const [arrayDays, setArrayDays] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [arrayDecToBin, setArrayDecToBin] = useState([]);

  const [AddarrayDays, setAddArrayDays] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [programArray, setProgramArray] = useState([]);

  const handleChange = (value: {
    hours: number;
    minutes: number;
    seconds: number;
  }) => {
    setHours(value.hours);
    setMinutes(value.minutes);
    setSeconds(value.seconds);
  };
  const handleReset = () => {
    setHours(0);
    setMinutes(0);
    setSeconds(0);
  };

  const [daysData, setDaysData] = useState([
    { id: 0, name: "Saturday" },
    { id: 1, name: "Friday" },
    { id: 2, name: "Thursday" },
    { id: 3, name: "Wednesday" },
    { id: 4, name: "Tuesday" },
    { id: 5, name: "Monday" },
    { id: 6, name: "Sunday" },
  ]);
  const [ProgramTypeIdData, setProgramTypeIdData] = useState([
    {
      id: 1,
      name: "CYCLIC",
    },
    {
      id: 2,
      name: "WEEKLY",
    },
  ]);


  const [programTypeAdd, setProgramTypeAdd] = useState("");
  const [programActionsSelect, setprogramActionsSelect] = useState("None");
  const [programActionsSelectId, setprogramActionsSelectId] = useState("");

  const [programActions, setProgramActions] = useState([
    {
      id: 1,
      name: "None",
    },
    {
      id: 2,
      name: "Pause",
    },
  ]);

  const [IrrigationStartData, setIrrigationStartData] = useState([
    {
      id: 1,
      name: "Cyclic",
    },
    {
      id: 2,
      name: "Hours",
    },
  ]);

  const [IrrigationStartSelect, setIrrigationStartSelect] = useState("");
  const [IrrigationNewStartSelect, setIrrigationNewStartSelect] = useState("");
  const [IrrigationNewStartSelectId, setIrrigationNewStartSelectId] =
    useState("");

  const [programTypevalueId, setprogramTypeValueiD] = useState("");
  const [programTypeIdValue, setprogramTypeIdValue] = useState("");

  const [daysvalueId, setDaysValueiD] = useState("");
  const [daysIdValue, setDaysIdValue] = useState(null);

  const [irrigationValue, setIrrigationValue] = useState(null);

  const [rename, setrename] = useState(false);
  const [renameEditable, setrenameEditable] = useState();

  const [searchData, setSearch] = useState("");
  const [filterData, setFilteredDataSource] = useState([]);
  const [isScheduleProgramNameDataValid, setScheduleProgramNameDataValid] =
    useState(false);
  const [isScheduleProgramNameDataEntered, setScheduleProgramNameDataEntered] =
    useState(false);
  const [sort, setsort] = useState(0);
  const [isstatuschecked, setStatusChecked] = useState(1);
  const [isMeasureType, setMeasureType] = useState("Duration");
  const [CountryName, setCountryNameData] = useState([]);

  const [AddValveItems, setAddValveItems] = useState([]);
  const [valveid, setvalveid] = useState("");
  const [valveUniqueId, setvalveUniqueId] = useState("");

  const [selectedId, setSelectedId] = useState(null);
  const [refresh, setrefresh] = useState(false);

  const [updateValveid, setUpdateValveid] = useState("");
  const [updateProjectName, setUpdateProjectName] = useState("");
  const [updatetimeStartValue, setUpdatetimeStartValue] = useState("");
  const [updatetimeEndValue, setUpdatetimeEndValue] = useState("");
  const [updateAddbinaryToDecimal, setUpdateAddbinaryToDecimal] = useState("");

  const [date, setDate] = React.useState<Date | undefined>(undefined);
  const [open, setOpen] = React.useState(false);

  const onDismissSingle = React.useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const checkOpenDate = (index: any) => {
    setOpen(true);
  };
  const onConfirmSingle = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setOpen(false);
      setDate(params.date);

      OmegaDetails[indexforconfirmstarttime].startDate = params.date;
      setrefreshflatlist(!refreshflatlist);
    },
    [setOpen, setDate, indexforconfirmstarttime],
  );
  const onConfirmNewDate = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setOpen(false);
      setDate(params.date);
    },
    [setOpen],
  );

  const [ValveAmountTime, setValveAmountTime] = useState("");
  const [ValveAmountTimeValue, setValveAmountTimeValue] = useState("");
  const [prgValveAmountData, setValveAmountData] = useState([]);

  const [ValveAmountTimeVisible, setValveAmountTimeVisible] =
    React.useState(false);
  const onDismissValveAmountTime = React.useCallback(() => {
    setValveAmountTimeVisible(false);
  }, [setValveAmountTimeVisible]);

  const checkValveAmountVisible = (mainindex: any, index: any) => {
    setValveAmountTimeVisible(true);
  };

  

  const onConfirmValveAmountTime = React.useCallback(
    (valveIndex, itemIndex) => {
      var hours = valveIndex.hours;
      var minutes = valveIndex.minutes;

      setValveAmountTimeVisible(false);
      setValveAmountTime({ hours, minutes });
      const d = moment({ hours, minutes }).format("HH:mm:ss"); 
      const a = d.split(":"); 
      const result = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      setValveAmountTimeValue(result);

      var length =
        OmegaDetails[indexforconfirmstarttime].ProgramsAmountData.length;

      OmegaDetails[indexforconfirmstarttime].ProgramsAmountData[
        indexforvalve
      ].amount = result;
    },
    [
      setValveAmountTimeVisible,
      indexforconfirmstarttime,
      indexforvalve,
      OmegaDetails,
    ],
  );

  const [times, setTimes] = useState("");

  const [programStartTime, setprogramStartTime] = useState("");
  const [programStartValue, setprogramStartValue] = useState("");
  const [prgStartData, setPrgStartData] = useState([]);
  const [newprgStartData, setNewPrgStartData] = useState([]);
  const [newprgStartData1, setNewPrgStartData1] = useState([]);
  const [programStartTimeVisible, setprogramStartTimeVisible] =
    React.useState(false);
  const onDismissProgramStartTime = React.useCallback(() => {
    setprogramStartTimeVisible(false);
  }, [setprogramStartTimeVisible]);

  const checkProgramVisible = (index: any) => {
    setprogramStartTimeVisible(true);
  };

  const onConfirmProgramStartTime = React.useCallback(
    ({ hours, minutes }) => {
      setprogramStartTimeVisible(false);
      setprogramStartTime({ hours, minutes });
      const d = moment({ hours, minutes }).format("HH:mm:ss");
      const a = d.split(":");
      const result = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      setprogramStartValue(result);
      var hrDataLen =
        OmegaDetails[indexforconfirmstarttime].cycleTypeHours.length;
      OmegaDetails[indexforconfirmstarttime].cycleTypeHours[hrDataLen] = result;
      setPrgStartData(OmegaDetails[indexforconfirmstarttime].cycleTypeHours);
      setrefreshflatlist(!refreshflatlist);
    },
    [setprogramStartTimeVisible, indexforconfirmstarttime],
  );

  
  const onConfirmNewProgramStartTime = React.useCallback(
    ({ hours, minutes }) => {
      setprogramStrtTimeError("");
      setprogramStartTimeVisible(false);
      setprogramStartTime({ hours, minutes });

      const d = moment({ hours, minutes }).format("HH:mm:ss");
      const a = d.split(":");

      const result = `${a[0]}${a[1]}`; 

      var programstartdatalength = newprgStartData1.length;
      newprgStartData1[programstartdatalength] = result;

      setNewPrgStartData1((prev) => [...prev, result]);
      setrefreshflatlist(!refreshflatlist);
    },
    [],
  );

  const onConfirmNewProgramStartTime1 = React.useCallback(
    ({ hours, minutes }) => {
      const d = moment({ hours, minutes }).format("HH:mm:ss"); 
      newprgStartData1.push({ d });
      setNewPrgStartData1(newprgStartData1);
      setprogramStartTimeVisible(false);
    },
    [],
  );

  const [timeVisible, setTimeVisible] = React.useState(false);
  const [timeEndValue, setTimeEndValue] = useState(0);

  const onDismissTime = React.useCallback(() => {
    setTimeVisible(false);
  }, [setTimeVisible]);

  const checktimeEndvisible = (index: any) => {
    setTimeVisible(true);
  };
  const onConfirmTime = React.useCallback(
    ({ hours, minutes }) => {
      setTimeVisible(false);
      setTimes({ hours, minutes });

      const d = moment({ hours, minutes }).format("HH:mm:ss"); 
      const a = d.split(":"); 

      const result = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      setTimeEndValue(result);
      OmegaDetails[indexforconfirmstarttime].hourlyEnd = result;
      setrefreshflatlist(!refreshflatlist);
    },
    [setTimeVisible, indexforconfirmstarttime],
  );

  const onConfirmNewEndTime = React.useCallback(
    ({ hours, minutes }) => {
      setprogramEndTimeError("");
      setTimeVisible(false);
      setTimes({ hours, minutes });

      const d = moment({ hours, minutes }).format("HH:mm:ss"); 
      const a = d.split(":");

      const result = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      setTimeEndValue(result);

      setrefreshflatlist(!refreshflatlist);
    },
    [setTimeVisible],
  );
  const [timeStart, setTimeStart] = useState("");
  const [timeStartValue, setTimeStartValue] = useState(0);
  const [indexvalue, setvalueindex] = useState();

  const [timeStartVisible, setTimeStartVisible] = React.useState(false);
  const onDismissStartTime = React.useCallback(() => {
    setTimeStartVisible(false);
  }, [setTimeStartVisible]);

  const checktimestartvisible = (index: any) => {
    setTimeStartVisible(true);
  };

  const onConfirmStartTime = React.useCallback(
    ({ hours, minutes }) => {
      setTimeStartVisible(false);
      setTimeStart({ hours, minutes });
      onconfirmstarttimeresult();

      const d = moment({ hours, minutes }).format("HH:mm:ss"); 
      const a = d.split(":"); 
      const result = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      setTimeStartValue(result);

      OmegaDetails[indexforconfirmstarttime].hourlyStart = result;
    },
    [setTimeStartVisible, indexforconfirmstarttime],
  );

  const onnewConfirmStartTime = React.useCallback(
    ({ hours, minutes }) => {
      setprogramStrtTimeError("");
      setTimeStartVisible(false);
      setTimeStart({ hours, minutes });

      const d = moment({ hours, minutes }).format("HH:mm:ss"); 
      const a = d.split(":"); 
      const result = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      setTimeStartValue(result);
    },
    [setTimeStartVisible],
  );

  const onconfirmstarttimeresult = () => {};

  const [timeHoursInterval, setTimeHoursInterval] = useState("");
  const [timeHoursIntervalValue, setTimeHoursIntervalValue] = useState(0);

  const [timeHIVisible, setTimeHIVisible] = React.useState(false);
  const onDismissHITime = React.useCallback(() => {
    setTimeHIVisible(false);
  }, [setTimeHIVisible]);

  const checkTimeIntervalvisible = (index: any) => {
    setTimeHIVisible(true);
  };
  const onConfirmHITime = React.useCallback(
    ({ hours, minutes }) => {
      setTimeHIVisible(false);
      setTimeHoursInterval({ hours, minutes });

      const d = moment({ hours, minutes }).format("HH:mm:ss"); 
      const a = d.split(":"); 
      const result = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      setTimeHoursIntervalValue(result);
      OmegaDetails[indexforconfirmstarttime].cycleIntervalHours = result;

    },
    [setTimeHIVisible, indexforconfirmstarttime],
  );
  const onConfirmNewHITime = React.useCallback(
    ({ hours, minutes }) => {
      setprogramHoursError("");
      setTimeHIVisible(false);
      setTimeHoursInterval({ hours, minutes });

      const d = moment({ hours, minutes }).format("HH:mm:ss"); 
      const a = d.split(":"); 
      const result = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      setTimeHoursIntervalValue(result);

    },
    [setTimeHIVisible],
  );

  useEffect(() => {
    setisopen(false);
    setrename(false);
    setbreckloop(false);
    setOmegaDetails([]);
    setNewPrgStartData1([]);
    setProjectName("");
    setValveSelected([]);
    setAddSelectedDays([]);
    setprogramTypeIdValue("");
    setprogramTypeValueiD("");
    setIrrigationStartSelect("");
    setDate(undefined);
    setcount(0);
    setIrrigationNewStartSelect("Cyclic");
    setTimeStart("");
    setTimes("");
    setTimeHoursInterval("");
    setAddValveItems([]);
    setOmegaAddIdValue(null);
    setOmegaAddValueiD("");
    setSensorIdValue(null);
    setSensorValueiD("");
    setSensorvalueType("");
    setSensorStatusIdValue(null);
    setSensorStatusiD("");
    setrefresh(false);
  }, [refresh]);

  const [counter, setCounter] = useState();

  const [count, setcount] = useState(0);
  const [timeHr, settimeHr] = useState(0);
  const [timemin, settimemin] = useState(0);
  const [timesec, settimesec] = useState(0);

  const [timehms, settimehms] = useState();

  const [valveamount, setvalveamount] = useState<Number>(0);

  const timer = `${timeHr < 10 ? `0${timeHr}` : timeHr}:${
    timemin < 10 ? `0${timemin}` : timemin
  }:${timesec < 10 ? `0${timesec}` : timesec}`;

  const dropdownRefOmega = useRef();
  const dropdownRefPT = useRef();
  const dropdownRefIS = useRef();
  const dropdownRefDI = useRef();
  const dropdownRefST = useRef();
  const dropdownRefVS = useRef();

  const closeMenu = () => {
    dropdownRefOmega.current.close();
    dropdownRefPT.current.close();
    dropdownRefIS.current.close();
    dropdownRefDI.current.close();
    dropdownRefST.current.close();
    dropdownRefVS.current.close();

  };

  useEffect(() => {
    window.addEventListener("scroll", closeMenu);
    return () => window.removeEventListener("scroll", closeMenu);
  }, []);

  let socket;

  useEffect(() => {
    const connectWebSocket = () => {
      socket = new WebSocket(baseUrlSocket);

      socket.onopen = () => {
        sendMessage();
      };

      socket.onmessage = (event) => {
        const message = event.data;
        setSocketDetails(JSON.parse(message));
       
      };

      socket.onerror = (error) => {};

      socket.onclose = (event) => {};
    };

    connectWebSocket();
    setInterval(() => {
      sendMessage();
    }, 5000);

    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, [omegaid]);

  const sendMessage = async () => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      let jsonValue = await AsyncStorage.getItem("userData");
      let projValue = await AsyncStorage.getItem("projectData");

      if (projValue != null) {
        const data = projValue + "-" + omegaid;
        socket.send(data);
      } else if (jsonValue != null) {
        var userDetailsresponse = JSON.parse(jsonValue);
        const data = userDetailsresponse.project_selected + "-" + omegaid;
        socket.send(data);
      }
     
    }
  };

  
  useEffect(() => {
    const b = timer.split(":"); 
    const result = +b[0] * 60 * 60 + +b[1] * 60 + +b[2];
    setvalveamount(result);
  }, [timer]);

  

  useEffect(() => {
    getAdminData();
  }, [idProject]);

  useEffect(() => {
    for (let i = 0; i < AddarrayDays.length; i++) {
      AddarrayDays[i] = 0;
    }

    for (let i = 0; i < AddselectedDays.length; i++) {
      var indexDays = AddselectedDays[i];
      AddarrayDays[indexDays] = 1;
    }

    var toBinary = AddarrayDays.join("");

    var toBinaryToDec = parseInt(toBinary, 2);

    setAddBinaryToDecimal(toBinaryToDec);

  }, [AddselectedDays]);

  

  useFocusEffect(
    React.useCallback(() => {
      getAdminData();

    }, [projectId]),
  );
  

  useEffect(() => {
   
  }, []);

  
  const socketDataRun = (omegaId, project_Id) => {
    socketServices.on("connect", () => {
      
      if (
        socketServices.socket.id != undefined &&
        project_Id != "" &&
        omegaId != ""
      ) {
        socketServices.emit("message", {
          project_id: project_Id,
          device_id: omegaId, 
          id: `${Math.random()}`, 
          socketID: socketServices.socket.id,
        });
      }

      socketServices.on("receive_message", (data: any) => {
        let bytes = CryptoJS.AES.decrypt(data, "secret key 123");
        let originalText = bytes.toString(CryptoJS.enc.Utf8);

        setSocketDetails(JSON.parse(originalText));
      });

      
    });
  };
  const onSelectedItemsChange = (
    valueDays: string | any[] | ((prevState: never[]) => never[]),
    index: any,
  ) => {



    OmegaDetails[index].idarr = valueDays;

    for (let i = 0; i < arrayDays.length; i++) {
      arrayDays[i] = 0;
    }

    for (let i = 0; i < OmegaDetails[index].idarr.length; i++) {
      var indexDays = OmegaDetails[index].idarr[i];
      arrayDays[indexDays] = 1;
    }

    var toBinary = arrayDays.join("");

    var toBinaryToDec = parseInt(toBinary, 2);

    setBinaryToDecimal(toBinaryToDec);
    setrefreshflatlist(!refreshflatlist);

    var id = 0;
    for (let i = 0; i < valueDays.length; i++) {
      var tempItem = daysData.find((item) => item.id === valueDays[i]);
      id = tempItem.id - 1;
    }
  };

  const onSelectedAddItemsChange = (
    selectedDays: string | any[] | ((prevState: never[]) => never[]),
  ) => {
    setProgDaysError("");

    setAddSelectedDays(selectedDays);
    var id = 0;
    for (let i = 0; i < selectedDays.length; i++) {
      var tempItem = daysData.find((item) => item.id === selectedDays[i]);
      id = tempItem.id - 1;
    }
  };

  const CheckEnteredData = async () => {
    if (
      valveid == "" &&
      timeStartValue == 0 &&
      timeEndValue == 0 &&
      timeHoursInterval == "" &&
      AddbinaryToDecimal == " " &&
      newProjectName == "" &&
      AddValveError == ""

    ) {
      setAddValveError("Select Valve");
      setprogNameError("select name");
      setprogramStrtTimeError("select program time");
      setProgDaysError("select days");
      setprogramEndTimeError("select end time");
      setprogramHoursError("select hours");

    } else {
      isopen ? createProgramData() : updateProgramData();
    }
  };

  const CheckUpdateEnteredData = (index, pid) => {
    updateProgramData(index, pid);
  };
  const EmptyListMessage = () => {
    return (
      <View style={{ justifyContent: "center" }}>
        <Text style={styles.emptyListStyle}>No Program Data Found</Text>
      </View>
    );
  };
  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    let projValue = await AsyncStorage.getItem("projectData");

    if (projValue != null) {
      setProjectId(projValue);
      getOmegaDependentByProjectId(projValue);
      getDeviceDependentByProjectId(projValue);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);
      setProjectId(userDetailsresponse.project_selected);
      getOmegaDependentByProjectId(userDetailsresponse.project_selected);
      getDeviceDependentByProjectId(userDetailsresponse.project_selected);
    }
  };
  const createProgramData = async () => {
    setIsLoading(true);

    try {
      if (!newProjectName) {
        setIsLoading(false);
        setprogNameError("select name");
        return;
      }
      const programAmount = programAmountFunction(selectedValveItems);
      var ProgramData = JSON.stringify({
        module: "programs",
        data: {
          omega_id: omegaid,
          bermad_valve_id: valveid,
          device_id: OmegaAddvalueId == "" ? null : OmegaAddvalueId,
          valve_id: valveUniqueId,
          project_id: projectId,
          allowedHoursEnd: 0,
          allowedHoursStart: 0,
          cycleDayStartHour: 1400,
          cycleIntervalDays: count,
          cycleIntervalHours: timeHoursIntervalValue,
          cyclePerDay: 1,
          cycleTypeIsCyclic:
            IrrigationNewStartSelect == "Cyclic" ? true : false,
          cycleTypeHours: newprgStartData1,
          irrigationScheduleTimes: newprgStartData1,
          endTimeMode: false,
          hourlyEnd: timeEndValue,
          hourlyStart: timeStartValue,
          irrigationDays: AddbinaryToDecimal,
          measurementType: isMeasureType,
          program_name: newProjectName,
          amount: parseInt(valveamount),
          order: 0,
          startDate: date,
          status: "ACTIVE",
          type: programTypeIdValue,
          programAmount: programAmount,
        },
      });

      const AddProgramResponse = await postData(
        ProgramData,
        "masters/createUpdatePrograms",
      );

      setIsLoading(false);

      var code = AddProgramResponse.code;
      if (code == 1) {
        navigation.navigate("ScheduleProgram");
        getOmegaDetails(projectId, omegaid);
        setrefresh(true);
        setisopen(false);
        setPopupMessage("Program Created Successfully");
        setissuccessVisible(true);
        setresponsestatus("success");
        setrefreshflatlist(!refreshflatlist);
      } else {
        setIsLoading(false);
        setissuccessVisible(true);
        setresponsestatus("failed");
        setPopupMessage("Something Went Wrong");

      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const programAmountFunction = (selectedValveItems) => {
    const programAmount = selectedValveItems.map((valve, index) => ({
      amount: Number(valve.amount),
      order: index,
      valve: {
        connect: {
          id: valve.id,
        },
      },
    }));

    return programAmount;
  };

  function getIrrigationDaysById(id) {
    const filteredItem = programArray.find((item) => item.id === id);

    if (filteredItem) {
      return filteredItem.irrigationDays;
    }
    return null; 
  }

  const updateProgramData = async (index, pid) => {
    setIsLoading(true);
    try {
      const programsAmountData = OmegaDetails[index].ProgramsAmountData;
      const inputArray =
        programsAmountData !== undefined
          ? programsAmountData
          : ProgramAmountDetails;
      const outputArray = inputArray.map((item) => {
        let valveId;
        if (item.valve && item.valve.connect && item.valve.connect.id) {
          valveId = item.valve.connect.id;
        } else if (item.bermad_valve_id) {
          valveId = item.bermad_valve_id;
        } else {
          valveId = null;
        }
        return {
          amount: item.amount,
          order: item.order,
          valve: { connect: { id: valveId } },
        };
      });

      const outputJSON = JSON.parse(JSON.stringify(outputArray, null, 2));

      const irregretionDays = await getIrrigationDaysById(pid);

      if (
        prgStartData.length === 0 &&
        OmegaDetails[index].cycleTypeHours.length === 0
      ) {
        setIsLoading(false);
        setissuccessVisible(true);
        setresponsestatus("failed");
        setPopupMessage("Add Start Time");
        return;
      }

      if (outputJSON.length === 0) {
        setIsLoading(false);
        setissuccessVisible(true);
        setresponsestatus("failed");
        setPopupMessage("Add at least One Valve");
        return;
      }

      var ProgramData = JSON.stringify({
        id: pid,
        module: "programs",
        data: {
          allowedHoursStart: 0,
          allowedHoursEnd: 0,
          omega_id: omegaid,
          measurementType: isMeasureType
            ? isMeasureType
            : OmegaDetails[index].measurementType,
          startDate: date ? date : OmegaDetails[index].startDate,
          cycleIntervalDays: counter
            ? counter
            : OmegaDetails[index].cyclePerDay,
          irrigationDays:
            binaryToDecimal != undefined ? binaryToDecimal : irregretionDays,
          program_index: 1234,
          cycleDayStartHour: 1400,
          cyclePerDay: 3,
          hourlyStart: timeStartValue
            ? timeStartValue
            : OmegaDetails[index].hourlyStart,
          cycleTypeHours:
            prgStartData.length > 0
              ? prgStartData
              : OmegaDetails[index].cycleTypeHours,
          hourlyEnd: timeEndValue
            ? timeEndValue
            : OmegaDetails[index].hourlyEnd,
          endTimeMode: false,
          cycleIntervalHours: timeHoursIntervalValue
            ? timeHoursIntervalValue
            : OmegaDetails[index].cycleIntervalHours,
          cycleTypeIsCyclic: IrrigationStartSelect == "Cyclic" ? true : false,
         
          programAmount: outputJSON,
          
          program_name: updateProjectName
            ? updateProjectName
            : OmegaDetails[index].program_name,
          description: "updated valuesss now",
          status: "ACTIVE",
          type: programTypeIdValue
            ? programTypeIdValue
            : OmegaDetails[index].type,
          device_id: DeviceNamevalueId == "" ? null : DeviceNamevalueId,
          valve_id: valveUniqueId,
          bermad_program_id: OmegaDetails[index].bermad_program_id,
          program_id: programsId,
          project_id: projectId,
        },
      });

      const UpdateProgramResponse = await postData(
        ProgramData,
        "masters/createUpdatePrograms",
      );

      setIsLoading(false);

      var code = UpdateProgramResponse.code;
      if (code == 1) {
        navigation.navigate("ScheduleProgram");
        getOmegaDetails(projectId, omegaid);

        setPopupMessage("Program Updated Successfully");
        setissuccessVisible(true);
        setresponsestatus("success");
        setrefreshflatlist(!refreshflatlist);
      } else {
        setIsLoading(false);
        setissuccessVisible(true);
        setresponsestatus("failed");
        setPopupMessage(UpdateProgramResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getOmegaDetails = async (project_Id: string, deviceId: string) => {
    setProjectName("");
    setOmegaDetails([]);
    setIsLoading(true);

    try {
      var OmegaDetails = JSON.stringify({
        project_id: project_Id,
        omega_id: deviceId,
      });

      const OmegaDetailsResponse = await postData(
        OmegaDetails,
        "masters/getPrograms",
      );
      setIsLoading(false);
      var code = OmegaDetailsResponse.code;

      if (code == 1) {
        setbreckloop(false);
        setShouldShow(false);
        setrefreshflatlist(!refreshflatlist);
        setProgramArray(OmegaDetailsResponse.data);
        var data = OmegaDetailsResponse.data;

        for (var i = 0; i < data.length; i++) {
          var idarr = [];
          var temp =
            data[i].irrigationDays != undefined
              ? data[i].irrigationDays.toString(2).padStart(7, "0").split("")
              : " ";

          for (var j = 0; j < temp.length; j++) {
            if (temp[j] == 1) {
              idarr.push(j);
            }
          }
          data[i].idarr = idarr;
        }

        setOmegaDetails(
          data.filter((rp: { status: string }) => rp.status != "DELETED"),
        );
        return data;

      } else {
        setIsLoading(false);
        setProgramLimitError(OmegaDetailsResponse.message);

        return "";
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getProgramSync = async () => {
    setIsLoadingSync(true);
    try {
      var programSyncData = JSON.stringify({
        project_id: projectId,
        omega_id: omegaid,
        device_id: OmegavalueId,
      });
      const programSyncResponse = await postData(
        programSyncData,
        "masters/ProgramsSynchronise",
      );

      setIsLoadingSync(false);
      var code = programSyncResponse.code;
      if (code == 1) {
        getOmegaDetails(projectId, omegaid);
      } else {
        setIsLoadingSync(false);
      }
    } catch (error) {
      setIsLoadingSync(false);
      console.error("Error", error);
    }
  };

  const deleteProgram = async (programId: any, omega_id) => {
    setIsLoading(true);
    try {
      var DeleteProgram = JSON.stringify({
        id: programId,
        module: "programs",
        data: {
          Omega_id: omega_id,
          status: "DELETED",
        },
      });
      const DeleteProgramResponse = await postData(
        DeleteProgram,
        "masters/deleteProgram",
      );
      setIsLoading(false);
      var code = DeleteProgramResponse.code;
      if (code == 1) {
        getOmegaDetails(projectId, omega_id);

      } else {
        setIsLoading(false);
        alert(DeleteProgramResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const startProgram = async (
    programIndex: any,
    BprogramId: string,
    omega_id,
  ) => {
    setIsLoading(true);
    try {
      var startProgram = JSON.stringify({
        index: programIndex,
        bermad_program_id: BprogramId,
        omega_id: omega_id,
      });
      const startProgramResponse = await postData(
        startProgram,
        "masters/startProgram",
      );
      setIsLoading(false);
      var code = startProgramResponse.code;
      if (code == 1) {
        getOmegaDetails(projectId, omega_id);

      } else {
        setIsLoading(false);
      }
      setrefreshflatlist(!refreshflatlist);
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const stopProgram = async (
    programIndex: any,
    BprogramId: string,
    omega_id,
  ) => {
    setIsLoading(true);
    try {
      var stopProgram = JSON.stringify({
        index: programIndex,
        bermad_program_id: BprogramId,
        omega_id: omega_id,
      });
      const stopProgramResponse = await postData(
        stopProgram,
        "masters/stopProgram",
      );
      setIsLoading(false);
      var code = stopProgramResponse.code;
      if (code == 1) {
        getOmegaDetails(projectId, omega_id);
      } else {
        setIsLoading(false);
      }
      setrefreshflatlist(!refreshflatlist);
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const pauseProgram = async (
    programIndex: any,
    BprogramId: string,
    omega_id,
  ) => {
    setIsLoading(true);
    try {
      var pauseProgram = JSON.stringify({
        index: programIndex,
        bermad_program_id: BprogramId,
        omega_id: omega_id,
      });
      const pauseProgramResponse = await postData(
        pauseProgram,
        "masters/pauseProgram",
      );
      setIsLoading(false);
      var code = pauseProgramResponse.code;
      if (code == 1) {
        getOmegaDetails(projectId, omega_id);
      } else {
        setIsLoading(false);
      }
      setrefreshflatlist(!refreshflatlist);
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const resumeProgram = async (
    programIndex: any,
    BprogramId: string,
    omega_id,
  ) => {
    setIsLoading(true);
    try {
      var resumeProgram = JSON.stringify({
        index: programIndex,
        bermad_program_id: BprogramId,
        omega_id: omega_id,
      });
      const resumeProgramResponse = await postData(
        resumeProgram,
        "masters/resumeProgram",
      );
      setIsLoading(false);
      var code = resumeProgramResponse.code;
      if (code == 1) {
        getOmegaDetails(projectId, omegaid);
      } else {
        setIsLoading(false);
      }
      setrefreshflatlist(!refreshflatlist);
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const updatePrograms = async (programId: any, status: string) => {
    setIsLoading(true);
    try {
      var updatePrograms = JSON.stringify({
        id: programId,
        module: "programs",
        data: {
          Omega_id: omegaid,
          status: status,
        },
      });
      const updateProgramsResponse = await postData(
        updatePrograms,
        "masters/updateProgramstatus",
      );
      setIsLoading(false);
      var code = updateProgramsResponse.code;
      if (code == 1) {
        getOmegaDetails(projectId, omegaid);
      } else {
        setIsLoading(false);
      }
      setrefreshflatlist(!refreshflatlist);
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getValveOmegaDetails = async (deviceId: any) => {
    setIsLoading(true);
    try {
      var OmegaDetails = JSON.stringify({
        device_id: deviceId,
      });
      const OmegaDetailsResponse = await postData(
        OmegaDetails,
        "masters/getOmegaDetails",
      );
      setIsLoading(false);
      var code = OmegaDetailsResponse.code;
      if (code == 1) {
        const mergeResult = OmegaDetailsResponse.data[0].digitalInput.concat(
          OmegaDetailsResponse.data[0].analogInput,
        );

        setValveDetails(OmegaDetailsResponse.data[0].valves);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getSensorOmegaDetails = async (deviceId: any) => {
    try {
      var OmegaDetails = JSON.stringify({
        device_id: deviceId,
      });
      const OmegaDetailsResponse = await postData(
        OmegaDetails,
        "masters/getOmegaDetails",
      );
      setIsLoading(false);
      var code = OmegaDetailsResponse.code;
      if (code == 1) {
        const mergeResult = OmegaDetailsResponse.data[0].digitalInput.concat(
          OmegaDetailsResponse.data[0].analogInput,
        );

        mergeResult.push({
          digital_id: null,
          id: 0,
          name: "None",
          type: 0,
          value: "0",
        });

        setSensorTypeDetails(mergeResult);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getOmegaDependentByProjectId = async (project_id: any) => {
    setIsLoading(true);
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: project_id,
        module: "devices_master",
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = OmegaIdList.code;

      if (code == 1) {
        setOmegaIdData(OmegaIdList.data);

        var omgData = await getOmegaDetails(
          project_id,
          OmegaIdList.data[0].omega_id,
        );
        if (omgData != undefined && omgData.length > 0) {
          setomegaid(OmegaIdList.data[0].omega_id);
          setOmegaValueiD(OmegaIdList.data[0].id);
          setOmegaAddValueiD(OmegaIdList.data[0].id);
          setOmegaIdName(OmegaIdList.data[0].device_name);
          getValveOmegaDetails(OmegaIdList.data[0].id);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getDeviceDependentByProjectId = async (project_id: any) => {
    setIsLoading(true);
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: project_id,
        module: "devices_master",
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = OmegaIdList.code;
      if (code == 1) {
        var arrData = OmegaIdList.data.push({
          id: 0,
          project_id: projectId,
          omega_id: null,
          device_name: "None",
          lat: null,
          long: null,
          active: 1,
        });
        setDeviceNameData(OmegaIdList.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getAllScheduleProgramProfileData = async (sortdata: never[]) => {
    setIsLoading(true);
    if (sortdata.length > 0) {
      setScheduleProgramDataLength(sortdata.length);
      setScheduleProgramNameData(sortdata);
      setFilteredDataSource(sortdata);
    } else {
      try {
        var getScheduleProgramData = JSON.stringify({
          module: "ScheduleProgram_master",
          relation: [],
        });
        const ScheduleProgramNameResponse = await postData(
          getScheduleProgramData,
          "masters/getMasterList",
        );
        setIsLoading(false);
        var code = ScheduleProgramNameResponse.code;
        if (code == 1) {
          setScheduleProgramDataLength(ScheduleProgramNameResponse.data.length);
          setScheduleProgramNameData(ScheduleProgramNameResponse.data);
          setFilteredDataSource(ScheduleProgramNameResponse.data);
          const results = jsonToCSV(ScheduleProgramNameResponse.data);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error", error);
      }
    }
  };

  const updateProgramName = async (bermadProgramId) => {
    try {
      var getScheduleProgramData = JSON.stringify({
        bermad_program_id: bermadProgramId,
        program_name: updateProjectName,
      });
      const renameProgramNameResponse = await postData(
        getScheduleProgramData,
        "masters/renameProgram",
      );
      setIsLoading(false);
      var code = renameProgramNameResponse.code;
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const isCreatable = (index: React.SetStateAction<string>) => {
    setmainindexmodal(index);
    setIsVisible(true);
    setisAdd(true);
  };

  const isvalveCreatable = () => {
    setValveIsVisible(true);
    setisAdd(true);
  };
  var flatIndexNext = 0;
  const nextPress = () => {
    if (OmegaDetails.length > flatIndexNext) {
      flatIndexNext = flatIndexNext + 4;
      flatListRef?.current?.scrollToIndex({
        animated: true,
        index: flatIndexNext,
      });
    }

  };

  const backPress = () => {
    if (flatIndexNext >= 4) {
      flatIndexNext = flatIndexNext - 4;
      flatListRef?.current?.scrollToIndex({
        animated: true,
        index: flatIndexNext,
      });
    }
  };
  const renderSensorType = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.name}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.name}</Text>}
        {item.id === sensorStatusId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };

  const renderOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === OmegavalueId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };
  const renderAddOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === OmegaAddvalueId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };

  const renderDeviceNameListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === DeviceNamevalueId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };
  const renderSensorListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.name}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.name}</Text>}
        {item.id === SensorvalueId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };
  const renderProgramType = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>
            {item.name.charAt(0).toUpperCase() +
              item.name.slice(1).toLowerCase()}
          </Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>
            {item.name.charAt(0).toUpperCase() +
              item.name.slice(1).toLowerCase()}
          </Text>
        )}
        {item.id === programTypevalueId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };

  const renderIrrigation = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.name}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.name}</Text>}
        {item.id === IrrigationNewStartSelectId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };
  const renderProgAction = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.name}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.name}</Text>}
        {item.id === programActionsSelectId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };

  const renderDaysType = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.name}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.name}</Text>}
        {item.id === daysvalueId && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };

  const renderItemScedular = ({ item, index }) => {
    var valve_error = "";
    setAddValveError(valve_error);
    var mainindex = index;
    var leftover = 0;
    var state = 0;
    var valveIndex = 0;
    var mainsIndex = "";
    var colorGray = "#0089d1";

    const tempArr = [];
    try {
      if (socketDetails[0].programs && socketDetails[0].programs.length > 0) {
        for (let j = 0; j < socketDetails[0].programs.length; j++) {
          if (
            socketDetails[0].programs[j].index ===
            OmegaDetails[mainindex].program_index
          ) {
            tempArr.push(socketDetails[0].programs[j].index);
            mainsIndex = socketDetails[0].programs[j].index;
            valveIndex = socketDetails[0].programs[j].valve;
            leftover = socketDetails[0].programs[j].leftover;
            state = socketDetails[0].programs[j].state;
            if (state == 1) {
              colorGray = "#5afc4c"; 
            }
            if (state == 2) {
              colorGray = "#ffc401"; 
            }
            if (state == 3) {
              colorGray = "#ffc401"; 
            }
            if (state == 4) {
              colorGray = "#bababa"; 
            }
            if (state == 5) {
              colorGray = "#bababa"; 
            }
          } else {
            if (tempArr.length > 0) {
              for (let k = 0; j < tempArr.length; j++) {
                if (tempArr[k] === OmegaDetails[mainindex].program_index) {
                  mainsIndex = socketDetails[0].programs[j].index;
                  valveIndex = socketDetails[0].programs[j].valve;
                  leftover = socketDetails[0].programs[j].leftover;
                  state = socketDetails[0].programs[j].state;
                }
              }
            } else {
              leftover = 0;
              state = 0;
              colorGray = "#bababa";
            }
          }
        }
      } else {
        leftover = 0;
        state = 0;
        colorGray = "#bababa";
      }
    } catch (error) {
      console.error("Error", error);
    }

    return (
      <View style={{ width: "100%" }}>
        <View
          style={{
            minHeight: "5%",
            borderRightWidth: 3,
            borderRightColor: "#CCC",
            alignSelf: "flex-start",
            width: "100%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              backgroundColor: "#0089d1",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Icon
              color={item.status == "NON-ACTIVE" ? "#000000" : colorGray}
              name="circle"
              size={20}
              style={{ margin: 10 }}
            />

            {rename && renameEditable == index ? (
              <View
                style={{
                  backgroundColor: "#0089d1",
                  flexDirection: "row",
                }}
              >
                <TextInput
                  style={[styles.input, { width: "70%", color: "white" }]}
                  placeholder="Enter Program Name"
                  value={updateProjectName}
                  onChangeText={(value) => {
                    setUpdateProjectName(value);
                  }}
                />

                <Icon
                  color={"#70c270"}
                  name="check-circle-o"
                  size={30}
                  style={{ margin: 5 }}
                  onPress={() => {
                    if (updateProjectName !== "") {
                      setrename(false);
                      item.program_name = updateProjectName;
                      updateProgramName(item.bermad_program_id);
                    }
                  }}
                />

                <Icon
                  color={"#fa776b"}
                  name="times-circle-o"
                  size={30}
                  style={{ margin: 5 }}
                  onPress={() => {
                    setrename(false);
                  }}
                />
              </View>
            ) : (
              <Text
                style={{
                  marginVertical: 10,
                  color: "white",
                  width: "90%",
                  textAlign: "center",
                  fontWeight: "600",
                  fontSize: 18,
                }}
              >
                {item.program_name}
              </Text>
            )}
            {!rename && (
              <View
                style={{
                  width: "10%",
                  top: "10px",
                  backgroundColor: "#0089d1",
                }}
              >
                <Menu>
                  <MenuTrigger
                    text=""
                    customStyles={{
                      triggerWrapper: {
                        width: "100px",
                      },
                    }}
                    onPress={() => setSelectedId(item.id)}
                  >
                    <IconCross
                      color="#fff"
                      name="dots-three-vertical"
                      size={25}
                    />
                  </MenuTrigger>

                  <MenuOptions
                    customStyles={{}}
                    optionsContainerStyle={{
                      marginLeft: -250,
                      borderWidth: 1,
                      borderColor: "#7b757573",
                    }}
                  >
                    <MenuOption
                      style={{
                        borderBottomWidth: 1,
                        borderBottomColor: "#dacfcf",
                      }}
                      onSelect={() => deleteProgram(item.id, item.omega_id)}
                    >
                      <Text style={{ color: "red" }}>Delete</Text>
                    </MenuOption>
                    {colorGray === "#bababa" && (
                      <MenuOption
                        style={{
                          borderBottomWidth: 1,
                          borderBottomColor: "#dacfcf",
                        }}
                        onSelect={() =>
                          startProgram(
                            item.program_index,
                            item.bermad_program_id,
                            item.omega_id,
                          )
                        }
                        disabled={false}
                        text={"Start Program"}
                      />
                    )}

                    {colorGray === "#5afc4c" && (
                      <View>
                        <MenuOption
                          style={{
                            borderBottomWidth: 1,
                            borderBottomColor: "#dacfcf",
                          }}
                          onSelect={() =>
                            stopProgram(
                              item.program_index,
                              item.bermad_program_id,
                              item.omega_id,
                            )
                          }
                          disabled={false}
                          text={"Stop Program"}
                        />
                        <MenuOption
                          style={{
                            borderBottomWidth: 1,
                            borderBottomColor: "#dacfcf",
                          }}
                          onSelect={() =>
                            pauseProgram(
                              item.program_index,
                              item.bermad_program_id,
                              item.omega_id,
                            )
                          }
                          disabled={false}
                          text={"Pause Program"}
                        />
                      </View>
                    )}

                    {colorGray === "#ffc401" && (
                      <View>
                        <MenuOption
                          style={{
                            borderBottomWidth: 1,
                            borderBottomColor: "#dacfcf",
                          }}
                          onSelect={() =>
                            stopProgram(
                              item.program_index,
                              item.bermad_program_id,
                              item.omega_id,
                            )
                          }
                          disabled={false}
                          text={"Stop Program"}
                        />
                        <MenuOption
                          style={{
                            borderBottomWidth: 1,
                            borderBottomColor: "#dacfcf",
                          }}
                          onSelect={() =>
                            resumeProgram(
                              item.program_index,
                              item.bermad_program_id,
                              item.omega_id,
                            )
                          }
                          disabled={false}
                          text={"Resume Program"}
                        />
                      </View>
                    )}

                    <MenuOption
                      style={{
                        borderBottomWidth: 1,
                        borderBottomColor: "#dacfcf",
                      }}
                      onSelect={() =>
                        updatePrograms(
                          item.id,
                          item.status == "NON-ACTIVE" ? "ACTIVE" : "NON-ACTIVE",
                        )
                      }
                      disabled={false}
                      text={item.status == "NON-ACTIVE" ? "Enable" : "Disabled"}
                    />
                    <MenuOption
                      style={{
                        borderBottomWidth: 1,
                        borderBottomColor: "#dacfcf",
                      }}
                      onSelect={() => {
                        (setrename(true), setrenameEditable(index));
                      }}
                    >
                      <Text style={{ color: "black" }}>Rename</Text>
                    </MenuOption>
                  </MenuOptions>
                </Menu>
              </View>
            )}
          </View>
        </View>
        <View
          style={{
            alignSelf: "flex-start",
            width: "100%",
            marginTop: 0,
            flexDirection: "row",
          }}
        >
          <View style={{ borderRightWidth: 3, borderRightColor: "#DEDEDE" }}>
            <View
              style={{
                alignItems: "center",
                marginHorizontal: 5,
                flexDirection: "row",
                marginVertical: 5,
              }}
            >
              <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                Program Type
              </Text>
              <Dropdown
                ref={dropdownRefPT}
                style={{
                  borderColor: "#c3c3c3",
                  width: "43%",
                  alignItems: "center",
                  borderWidth: 1,
                  borderRadius: 5,
                  height: 25,
                  padding: 10,
                }}
                inputSearchStyle={styles.inputSearchStyle}
                search
                data={ProgramTypeIdData}
                maxHeight={300}
                labelField="name"
                valueField="name"
                placeholder={
                  item.type.charAt(0).toUpperCase() +
                  item.type.slice(1).toLowerCase()
                }
                searchPlaceholder="Search..."
                value={
                  OmegaDetails[index].type.charAt(0).toUpperCase() +
                  OmegaDetails[index].type.slice(1).toLowerCase()
                }
                onChange={(item) => {
                  OmegaDetails[index].type = item.name;
                  setprogramTypeIdValue(item.name);
                  setprogramTypeValueiD(item.id);

                  setOmegaError("");
                  setrefreshflatlist(!refreshflatlist);
                }}
                renderItem={renderProgramType}
              />
            </View>
            <View style={{ marginTop: 5 }}>
              {item.type === "WEEKLY" && (
                <View
                  style={{
                    alignItems: "center",
                    marginHorizontal: 5,
                    flexDirection: "row",
                  }}
                >
                  <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                    Program Days
                  </Text>

                  <MultiSelect
                    hideTags
                    fixedHeight={true}
                    items={daysData}
                    uniqueKey="id"
                    onSelectedItemsChange={(value) =>
                      onSelectedItemsChange(value, mainindex)
                    }
                    selectedItems={item.idarr}

                    selectText="Select"
                    searchInputPlaceholderText="Search Items Here..."
                    tagRemoveIconColor="#CCC"
                    tagBorderColor="#CCC"
                    tagTextColor="#CCC"
                    selectedItemTextColor="#009DF0"
                    selectedItemIconColor="#CCC"
                    itemTextColor="#000"
                    displayKey="name"
                    submitButtonColor="#fff"
                    submitButtonText="Submit"
                    searchInputStyle={styles.inputSearchStyle}
                    styleDropdownMenu={{ backgroundColor: "#fff" }}
                  />
                </View>
              )}

              {item.type === "CYCLIC" && (
                <View
                  style={{
                    marginTop: 1,
                    height: 90,

                    width: "95%",
                    alignSelf: "center",
                  }}
                >
                  <View
                    style={{
                      alignItems: "center",
                      flexDirection: "row",
                      marginTop: 5,
                    }}
                  >
                    <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                      Start Date
                    </Text>
                    <View style={{ width: "43%" }}>
                      <Text
                        style={{
                          borderColor: "gray",
                          borderWidth: 1,
                          textAlign: "center",
                          borderRadius: 5,
                          padding: 2,
                        }}
                        onPress={() => {
                          setindexforconfirmstarttime(index);
                          checkOpenDate(index);
                        }}
                      >
                        {moment(item.startDate).format("YYYY-MM-DD")}
                      </Text>
                      <DatePickerModal
                        locale="en"
                        mode="single"
                        visible={open}
                        onDismiss={onDismissSingle}
                        date={date}
                        onConfirm={onConfirmSingle}
                        validRange={{
                          endDate: new Date(),
                        }}
                        label="Select date" 
                        closeIcon="close"
                        calendarIcon="calendar"
                      />
                    </View>
                  </View>
                  <View
                    style={{
                      flex: 1,
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                      Day's Interval
                    </Text>
                    <View style={{ flexDirection: "row", width: "37%" }}>
                      <TouchableOpacity
                        onPress={() => {
                          (setCounter(item.cycleIntervalDays),
                            item.cycleIntervalDays > 0 &&
                              (item.cycleIntervalDays =
                                item.cycleIntervalDays - 1),
                            setrefreshflatlist(!refreshflatlist));
                        }}
                      >
                        <Text style={{ marginHorizontal: 5 }}>
                          <IconPlusMinus
                            color="#767676"
                            name="minuscircleo"
                            size={20}
                          />
                        </Text>
                      </TouchableOpacity>

                      <Text
                        style={{
                          borderWidth: 1,
                          marginHorizontal: 5,
                          paddingHorizontal: 5,
                          borderColor: "#707070",
                          borderRadius: 6,
                        }}
                      >
                        {item.cycleIntervalDays}{" "}
                      </Text>

                      <TouchableOpacity
                        onPress={() => {
                          (setCounter(item.cycleIntervalDays),
                            item.cycleIntervalDays < 15 &&
                              (item.cycleIntervalDays =
                                item.cycleIntervalDays + 1),
                            setrefreshflatlist(!refreshflatlist));
                        }}
                      >
                        <Text style={{ marginHorizontal: 5 }}>
                          <IconPlusMinus
                            color="#767676"
                            name="pluscircleo"
                            size={20}
                          />
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              )}
            </View>

            <View style={{ height: "36%" }}>
              <View
                style={{
                  alignItems: "center",
                  marginHorizontal: 5,
                  flexDirection: "row",
                  marginTop: 10,
                }}
              >
                <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                  Program Start
                </Text>
                <Dropdown
                  ref={dropdownRefIS}
                  style={{
                    borderColor: "#c3c3c3",
                    width: "40%",
                    alignItems: "center",
                    borderWidth: 1,
                    borderRadius: 5,
                    height: 30,
                    padding: 10,
                  }}
                  inputSearchStyle={styles.inputSearchStyle}
                  search
                  data={IrrigationStartData}
                  maxHeight={300}
                  labelField="name"
                  valueField="name"
                  placeholder={"select "}
                  searchPlaceholder="Search..."
                  value={
                    OmegaDetails[index].cycleTypeIsCyclic == true
                      ? "Cyclic"
                      : "Hours"
                  }
                  onChange={(item) => {
                    OmegaDetails[index].cycleTypeIsCyclic =
                      item.id == 1 ? true : false;

                    setIrrigationStartSelect(item.name);

                  }}
                  renderItem={renderIrrigation}
                />
              </View>
              {OmegaDetails[index].cycleTypeIsCyclic == false && (
                <View>
                  <View
                    style={{
                      alignItems: "center",
                      marginHorizontal: 5,
                      flexDirection: "row",
                      marginTop: 5,
                    }}
                  >
                    <Text style={[{ flex: 0.7 }, styles.schedulHead]}>
                      Program Start Times
                    </Text>

                    {OmegaDetails[index].cycleTypeHours.length <= 3 ? (
                      <Pressable
                        onPress={() => {
                          (setindexforconfirmstarttime(index),
                            checkProgramVisible(index));
                        }}
                        style={{
                          borderWidth: 1,
                          width: "40%",
                          marginBottom: 20,
                          marginRight: 20,
                          borderColor: "#707070",
                          borderRadius: 5,
                          backgroundColor: "#EBEBEB",
                          padding: 5,
                          alignItems: "center",
                          alignSelf: "flex-end",
                          marginRight: -50,
                          marginTop: 15,
                        }}
                      >
                        <Text
                          style={[
                            styles.valvebtnText,
                            { textAlign: "center", fontWeight: "400" },
                          ]}
                        >
                          Add start time
                        </Text>
                      </Pressable>
                    ) : (
                      <Pressable
                        disabled
                        onPress={() => {
                          (setindexforconfirmstarttime(index),
                            checkProgramVisible(index));
                        }}
                        style={{
                          backgroundColor: "#EBEBEB",
                          width: "40%",
                          marginRight: 20,
                          marginBottom: 20,
                          padding: 5,
                          alignItems: "center",
                          borderWidth: 1,
                          borderRadius: 5,
                          borderColor: "#707070",
                          alignSelf: "flex-end",
                          marginRight: -50,
                          marginTop: 15,
                        }}
                      >
                        <Text
                          style={{
                            fontWeight: "400",
                            textAlign: "center",
                            color: "#CCC",
                          }}
                        >
                          Add start time
                        </Text>
                      </Pressable>
                    )}
                    <TimePickerModal
                      visible={programStartTimeVisible}
                      onDismiss={onDismissProgramStartTime}
                      onConfirm={onConfirmProgramStartTime}
                      
                      data={programStartTime}
                      hours={0o0} 
                      minutes={0o0} 
                      locale="de"
                    />
                  </View>
                  <View>
                    <FlatList
                      style={{ width: "100%", marginTop: -10 }}
                      extraData={refreshflatlist}
                      contentContainerStyle={{ height: 90 }}
                      data={OmegaDetails[index].cycleTypeHours}
                      renderItem={(item) =>
                        renderProgramStartTimeItems(item, index)
                      }
                      keyExtractor={(item, index) => item.index}
                    />
                  </View>
                </View>
              )}
              {OmegaDetails[index].cycleTypeIsCyclic == true && (
                <View>
                  <View
                    style={{
                      flex: 1,
                      alignItems: "center",
                      marginHorizontal: 5,
                      flexDirection: "row",
                      marginTop: 5,
                    }}
                  >
                    <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                      Program Start Time
                    </Text>
                    <View
                      style={{
                        borderWidth: 1,
                        borderColor: "grey",
                        width: "40%",
                        height: 30,
                        alignSelf: "center",
                        alignItems: "center",
                        borderRadius: 5,
                      }}
                    >
                      <Text
                        style={{ margin: 5 }}
                        onPress={() => {
                          setindexforconfirmstarttime(index);
                          checktimestartvisible(index);
                        }}
                      >
                        {new Date(item.hourlyStart * 1000)
                          .toISOString()
                          .slice(11, 19)}
                      </Text>

                      <TimePickerModal
                        visible={timeStartVisible}
                        onDismiss={onDismissStartTime}
                        onConfirm={onConfirmStartTime}
                        
                        data={timeStart}
                        hours={0o0} 
                        minutes={0o0} 
                        locale="de"
                        
                      />
                    </View>
                  </View>
                  <View
                    style={{
                      flex: 1,
                      alignItems: "center",
                      marginHorizontal: 5,
                      flexDirection: "row",
                      marginTop: 5,
                    }}
                  >
                    <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                      Program End Time
                    </Text>
                    <View
                      style={{
                        borderWidth: 1,
                        borderColor: "grey",
                        width: "40%",
                        height: 30,
                        alignSelf: "center",
                        alignItems: "center",
                        borderRadius: 5,
                      }}
                    >
                      <Text
                        style={{ margin: 5 }}
                        onPress={() => {
                          setindexforconfirmstarttime(index);
                          checktimeEndvisible(index);
                        }}
                      >
                        {new Date(item.hourlyEnd * 1000)
                          .toISOString()
                          .slice(11, 19)}
                      </Text>

                      <TimePickerModal
                        visible={timeVisible}
                        onDismiss={onDismissTime}
                        onConfirm={onConfirmTime}
                        
                        data={times}
                        hours={0o0} 
                        minutes={0o0} 
                        locale="de"
                      />
                    </View>
                  </View>
                  <View
                    style={{
                      flex: 1,
                      alignItems: "center",
                      marginHorizontal: 5,
                      flexDirection: "row",
                      marginTop: 5,
                    }}
                  >
                    <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                      Hours Interval
                    </Text>
                    <View
                      style={{
                        borderWidth: 1,
                        borderColor: "grey",
                        width: "40%",
                        height: 30,
                        alignSelf: "center",
                        alignItems: "center",
                        borderRadius: 5,
                      }}
                    >
                      <Text
                        style={{ margin: 5 }}
                        onPress={() => {
                          setindexforconfirmstarttime(index);
                          checkTimeIntervalvisible(index);
                        }}
                      >
                        {new Date(item.cycleIntervalHours * 1000)
                          .toISOString()
                          .slice(11, 19)}
                      </Text>

                      <TimePickerModal
                        visible={timeHIVisible}
                        onDismiss={onDismissHITime}
                        onConfirm={onConfirmHITime}
                        
                        data={timeHoursInterval}
                        hours={0o0} 
                        minutes={0o0} 
                        locale="de"
                      />
                    </View>
                  </View>
                </View>
              )}
            </View>

            <View
              style={{
                marginTop: 6,
                height: 0.5,
                width: "100%",
                alignSelf: "center",
                backgroundColor: "grey",
              }}
            />

            <View
              style={{
                height:
                  item.ProgramsAmountData.length == 0
                    ? 130
                    : item.ProgramsAmountData.length == 1
                      ? 200
                      : item.ProgramsAmountData.length == 2
                        ? 250
                        : item.ProgramsAmountData.length > 2
                          ? 250
                          : 250,
              }}
            >
              <View
                style={{
                  alignItems: "center",
                  marginHorizontal: 5,
                  flexDirection: "row",
                  marginTop: 10,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    flex: 1,
                    alignItems: "center",
                  }}
                >
                  <Text style={[{ flex: 0.7 }, styles.schedulHead]}>
                    Measurement Type
                  </Text>
                  {OmegaDetails[index].measurementype && (
                    <Text
                      style={{
                        textAlign: "center",
                        fontSize: 14,
                        flex: 0.3,
                        color: "black",
                        borderWidth: 1,
                        borderColor: "grey",
                        padding: 3,
                        borderRadius: 3,
                      }}
                    >
                      {OmegaDetails[index].measurementype}
                    </Text>
                  )}
                </View>
              </View>
              `{" "}
              <View style={{ marginHorizontal: 5, marginTop: -5 }}>
                <View style={{ flexDirection: "row" }}>
                  <Text style={[{ flex: 1 }, styles.schedulHead]}>
                    Valve Sequence in Program{" "}
                  </Text>
                  <Pressable
                    onPress={() => {
                      setProgramAmountDetails(
                        OmegaDetails[index].ProgramsAmountData,
                      );

                      (setmeasurementType(item.measurementype),
                        setvalveamount(0));
                      (setprogramAmount(item.ProgramsAmountData.sort()),
                        isCreatable(index));
                      setupdatedata(
                        ProgramAmountDetails.length > 0 ? false : true,
                      );
                      OmegaDetails[index].ProgramsAmountData = [];
                    }}
                    style={{
                      flexDirection: "row",
                      backgroundColor: "#EBEBEB",
                      padding: 5,
                      borderWidth: 1,
                      marginRight: 5,
                      borderColor: "#707070",
                      borderRadius: 5,
                      alignItems: "center",
                      alignSelf: "flex-end",
                      marginVertical: 10,
                      marginTop: -5,
                      marginLeft: 40,
                    }}
                  >
                    <Icon
                      color="#747474"
                      name="plus"
                      size={15}
                      style={{ marginRight: 4 }}
                    />
                    <Text style={styles.valvebtnText}>Add Valve</Text>
                  </Pressable>
                </View>
                <FlatList
                  contentContainerStyle={{
                   
                    height:
                      item.ProgramsAmountData.length == 0
                        ? 20
                        : item.ProgramsAmountData.length == 1
                          ? 50
                          : item.ProgramsAmountData.length == 2
                            ? 90
                            : item.ProgramsAmountData.length > 4
                              ? 170
                              : 170,
                  }}
                  data={item.ProgramsAmountData}
                  renderItem={({ item, index }) =>
                    renderValveItems(
                      item,
                      index,
                      mainindex,
                      OmegaDetails[mainindex].measurementype,
                      OmegaDetails[mainindex].program_index,
                      leftover,
                      mainsIndex,
                      valveIndex,
                    )
                  }
                  extraData={refreshflatlist}
                  keyExtractor={(item, index) => item.index}
                  scrollEnabled={item.ProgramsAmountData.length > 4}
                />
                `<Text style={[styles.error_text]}>{valve_error}</Text>
              </View>
            </View>
          </View>
        </View>

        <View
          style={{
            marginVertical: 10,
            height: 0.5,
            width: "100%",
            alignSelf: "center",
            backgroundColor: "grey",
          }}
        />
        <View
          style={{
            minHeight: "30%",
            alignSelf: "flex-start",
            marginTop: 0,
            width: "100%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "100%",
              borderRightWidth: 3,
              borderLeftWidth: 3,
              borderBottomWidth: 1,
              borderBottomColor: "#DEDEDE",
              borderRightColor: "#DEDEDE",
              borderLeftColor: "#DEDEDE",
            }}
          >
            <View
              style={{
                alignItems: "center",
                flexDirection: "row",
                marginBottom: 0,
              }}
            >
              <Text style={[{ flex: 0.9, marginLeft: 5 }, styles.schedulHead]}>
                Program Action
              </Text>
              <Dropdown
                style={{
                  borderColor: "#c3c3c3",
                  width: "45%",
                  borderWidth: 1,
                  borderRadius: 5,
                  height: 20,
                  padding: 10,
                }}
                placeholderStyle={styles.placeholderStyle}
                selectedTextStyle={styles.selectedTextStyle}
                inputSearchStyle={styles.inputSearchStyle}
                iconStyle={styles.iconStyle}
                search
                data={programActions}
                maxHeight={300}
                labelField="name"
                valueField="name"
                placeholder={
                  programActionsSelect ? programActionsSelect : "select action"
                }
                searchPlaceholder="Search..."
                value={programActionsSelect}
                onChange={(item) => {
                  setprogramActionsSelect(item.name);
                  setprogramActionsSelectId(item.id);
                }}
                renderItem={renderProgAction}
              />
            </View>

            {programActionsSelect === "None" ? null : (
              <View>
                <View
                  style={{
                    flex: 1,
                    alignItems: "center",
                    marginHorizontal: 5,
                    flexDirection: "row",
                    marginTop: 10,
                  }}
                >
                  <View style={{ flex: 0.85 }}>
                    <Text
                      style={[
                        { flex: 0.9, marginBottom: 5 },
                        styles.schedulHead,
                      ]}
                    >
                      Device
                    </Text>
                    <Dropdown
                      ref={dropdownRefDI}
                      style={{
                        borderColor: "#c3c3c3",
                        width: "80%",
                        borderWidth: 1,
                        borderRadius: 5,
                        height: 25,
                        padding: 10,
                      }}
                      data={deviceNameData}
                      search
                      maxHeight={300}
                      labelField="device_name"
                      valueField="device_name"
                      placeholder={!isFocus ? "Select" : "...."}
                      searchPlaceholder="Search..."
                      value={item.device_name}
                      onChange={(item) => {
                        setDeviceNameIdValue(item.device_name);
                        setDeviceNameValueiD(item.id);
                        getSensorOmegaDetails(item.id);
                        setOmegaError("");
                      }}
                      renderItem={renderDeviceNameListItems}
                    />
                    <Text style={[styles.error_text]}>{deviceError}</Text>
                  </View>
                </View>
                <View
                  style={{
                    flex: 1,
                    alignItems: "center",
                    marginHorizontal: 5,
                    flexDirection: "row",
                    marginTop: 10,
                  }}
                >
                  <View style={{ flex: 0.85 }}>
                    <Text
                      style={[
                        { flex: 0.9, marginBottom: 5 },
                        styles.schedulHead,
                      ]}
                    >
                      Sensor name
                    </Text>
                    <Dropdown
                      ref={dropdownRefST}
                      style={{
                        borderColor: "#c3c3c3",
                        width: "80%",
                        borderWidth: 1,
                        borderRadius: 5,
                        height: 20,
                        padding: 10,
                      }}
                      data={sensorTypeDetails}
                      search
                      maxHeight={300}
                      labelField="name"
                      valueField="name"
                      placeholder={
                        DeviceNameIdValue == "None" ? "None " : "Select"
                      }
                      searchPlaceholder="Search..."
                      value={item.name}
                      onChange={(value) => {
                        item.name = value.name;
                        setSensorIdValue(item.name);
                        setSensorValueiD(item.id);
                        setSensorvalueType(item.type);
                        setrefreshflatlist(!refreshflatlist);
                      }}
                      renderItem={renderSensorListItems}
                    />
                    <Text style={[styles.error_text]}>{StatusError}</Text>
                  </View>
                </View>
                <View
                  style={{
                    flex: 1,
                    alignItems: "center",
                    marginHorizontal: 5,
                    flexDirection: "row",
                    marginVertical: 10,
                  }}
                >
                  <View style={{ flex: 0.85 }}>
                    <Text
                      style={[
                        { flex: 0.9, marginBottom: 5 },
                        styles.schedulHead,
                      ]}
                    >
                      Value
                    </Text>
                    <View
                      style={{
                        flexDirection: "row",
                        borderRadius: 5,
                        width: "80%",
                        borderColor: "#707070",
                      }}
                    >
                      {SensorvalueType == 2 ? (
                        <View
                          style={{
                            height: 20,
                            width: "80%",
                            marginHorizontal: 2,
                          }}
                        >
                          <TextInput value=""></TextInput>
                        </View>
                      ) : (
                        <View>
                          <Dropdown
                            ref={dropdownRefVS}
                            style={{
                              borderColor: "#c3c3c3",
                              width: "100%",
                              borderWidth: 1,
                              borderRadius: 5,
                              height: 20,
                              padding: 10,
                            }}
                            search
                            data={sensorStatus}
                            maxHeight={300}
                            labelField="name"
                            valueField="id"
                            placeholder={"Status"}
                            searchPlaceholder="Search..."
                            value={SensorIdValue}
                            onChange={(item) => {
                              setSensorStatusIdValue(item.name);
                              setSensorStatusiD(item.id);
                              setrefreshflatlist((prev) => !prev);
                            }}
                            renderItem={renderSensorType}
                          />
                          <Text style={[styles.error_text]}>{valveError}</Text>
                        </View>
                      )}
                    </View>
                  </View>
                </View>
              </View>
            )}

            <View
              style={{
                alignSelf: "center",
                marginBottom: 10,
                marginTop: 5,
                paddingTop: 2,
                alignItems: "center",
              }}
            >
              <TouchableOpacity
                style={styles.addDevice}
                onPress={() => {
                  setProgramsId(item.id);
                  setBermadProgramId(item.bermad_program_id);
                  setUpdateProgramIndex(index);
                  CheckUpdateEnteredData(index, item.id);
                }}
              >
                <Text style={styles.btnText}>Save Changes</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    );
  };

  const deleteSelectedElement = (
    id: any,
    name: any,
    mainindex: string | number,
  ) => {
    const filteredData = OmegaDetails[mainindex].ProgramsAmountData.filter(
      (item: { name: any }) => item.name !== name,
    );

    OmegaDetails[mainindex].ProgramsAmountData = filteredData;
    setrefreshflatlist(!refreshflatlist);
  };
  const deleteAddValveItems = (id: any, name: any) => {
    const filteredvalueData = AddValveItems.filter(
      (item: { valve: { id: any } }) => item.valve.id !== id,
    );
    setAddValveItems(filteredvalueData);
  };
  const deleteProgramStartTime = (id: any, index: string | number) => {
    OmegaDetails[index].cycleTypeHours.splice(id, 1);

    setPrgStartData(OmegaDetails[index].cycleTypeHours);
    setrefreshflatlist(!refreshflatlist);
  };
  const deleteAddprogramItems = (id: any) => {
    newprgStartData1.splice(id, 1);

    setNewPrgStartData1(newprgStartData1);
    setrefreshflatlist(!refreshflatlist);

    
  };

  const renderValveItems = (
    item: {
      name:
        | string
        | number
        | boolean
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | React.ReactFragment
        | React.ReactPortal
        | null
        | undefined;
      amount: string | number | undefined;
      id: any;
      input_index: string | number;
    },
    index: number,
    mainindex: string | number,
    radiostatus: string,
    program_index: string | number,
    leftover: number,
    pindex: string | number,
    valveIndex: number,
  ) => {
    return (
      <View
        style={{
          flexDirection: "row",
          borderRadius: 5,
          marginTop: 5,
          borderWidth: 1,
          alignItems: "center",
          borderColor: "#DEDEDE",
        }}
      >
        <View
          style={{
            borderRightWidth: 1,
            flex: 0.4,
            alignItems: "center",
            borderColor: "#DEDEDE",
            height: 35,
          }}
        >
          <Text style={{ flex: 0.25, marginVertical: 8 }}>{item.name}</Text>
        </View>

        {radiostatus === "Quantity" ? (
          <View
            style={{
              flexDirection: "row",
              borderRightWidth: 1,
              borderRightColor: "#dedede",
              margin: 2,
            }}
          >
            <TextInput
              style={{
                width: 60,
                textAlign: "center",
                alignItems: "center",
                borderColor: "transparent",
                height: 35,
              }}
              value={item.amount}
              onChangeText={(text) => {
                ((OmegaDetails[mainindex].ProgramsAmountData[index].amount =
                  text),
                  setvalveamount(text),
                  setrefreshflatlist(!refreshflatlist));
              }}
            />

            <Text style={{ alignSelf: "center" }}>m³</Text>
          </View>
        ) : (
          <Pressable
            onPress={() => {
              setindexforconfirmstarttime(mainindex);
              setIndexValve(index);
              checkValveAmountVisible(mainindex, index);
            }}
            style={{
              borderRightWidth: 1,
              flex: 0.4,
              alignItems: "center",
              borderColor: "#DEDEDE",
              height: 35,
            }}
          >
            <Text style={{ flex: 0.25, marginVertical: 8 }}>
              {new Date(item.amount * 1000).toISOString().slice(11, 19)}
            </Text>
          </Pressable>
        )}
        <View
          style={{
            borderRightWidth: 1,
            flex: 0.45,
            borderColor: "#DEDEDE",
            alignItems: "center",
            height: 27,
          }}
        >
          <Text style={{ flex: 0.25, fontSize: 10 }}>Left Over</Text>
          {item.input_index == valveIndex && leftover > 0 ? (
            <Text style={{ flex: 0.25 }}>
              {radiostatus === "Duration"
                ? new Date(leftover * 1000).toISOString().slice(11, 19)
                : leftover}
            </Text>
          ) : (
            <Text style={{ flex: 0.25 }}>0</Text>
          )}
        </View>
        <View
          style={{
            flex: 0.2,
            alignItems: "center",
            borderColor: "#DEDEDE",
            height: 23,
          }}
        >
          <IconCross
            name="circle-with-cross"
            color="red"
            size={20}
            onPress={() => deleteSelectedElement(item.id, item.name, mainindex)}
          />
        </View>
        <TimePickerModal
          visible={ValveAmountTimeVisible}
          onDismiss={onDismissValveAmountTime}
          onConfirm={(valveIndex) =>
            onConfirmValveAmountTime(valveIndex, index)
          }
          data={ValveAmountTime}
          hours={0o0} 
          minutes={0o0} 
          locale="de"

         
        />
      </View>
    );
  };

  const renderProgramStartTimeItems = (
    item: ListRenderItemInfo<any>,
    index: any,
  ) => {
    var timeP = new Date(item.item * 1000).toISOString().slice(11, 19);
    return (
      <View
        style={{
          flexDirection: "row",
          width: "68%",
          alignSelf: "center",
          marginLeft: 17,
          borderRadius: 5,
          marginTop: 5,
          borderWidth: 1,
          alignItems: "flex-start",
          borderColor: "#DEDEDE",
        }}
      >
        <View
          style={{
            borderRightWidth: 1,
            flex: 1,
            alignItems: "center",
            borderColor: "#DEDEDE",
            height: 35,
          }}
        >
          <Text style={{ marginVertical: 8 }}>{timeP}</Text>
        </View>
        <View
          style={{
            alignItems: "center",
            padding: 5,
            borderColor: "#DEDEDE",
            height: 27,
          }}
        >
          <IconCross
            name="circle-with-cross"
            color="red"
            size={20}
            onPress={() => deleteProgramStartTime(item.index, index)}
          />
        </View>
      </View>
    );
  };
  const renderProgramAddStartTimeItems = (
    item: { item: number; index: any },
    index: any,
  ) => {
    var timeP = new Date(item.item * 1000).toISOString().slice(11, 19);
    return (
      <View
        style={{
          flexDirection: "row",
          borderRadius: 5,
          marginTop: 5,
          borderWidth: 1,
          alignItems: "center",
          borderColor: "#DEDEDE",
        }}
      >
        <View
          style={{
            borderRightWidth: 1,
            flex: 1,
            alignItems: "center",
            borderColor: "#DEDEDE",
            height: 35,
          }}
        >
          <Text style={{ flex: 0.4, marginVertical: 8 }}>{timeP}</Text>
        </View>
        <View
          style={{
            flex: 0.25,
            alignItems: "center",
            borderColor: "#DEDEDE",
            height: 27,
          }}
        >
          <IconCross
            name="circle-with-cross"
            color="red"
            size={25}
            onPress={() => deleteAddprogramItems(item.index)}
          />
        </View>
      </View>
    );
  };

  const renderAddValveItems = ({ item, index }) => {
    return (
      <View
        style={{
          flexDirection: "row",
          borderRadius: 5,
          marginTop: 5,
          borderWidth: 1,
          alignItems: "center",
          borderColor: "#DEDEDE",
        }}
      >
        <View
          style={{
            borderRightWidth: 1,
            flex: 0.25,
            alignItems: "center",
            borderColor: "#DEDEDE",
            height: 35,
          }}
        >
          <Text style={{ flex: 0.25, marginVertical: 8 }}>
            {item.valve.name}
          </Text>
        </View>

        <View
          style={{
            borderRightWidth: 1,
            flex: 0.6,
            alignItems: "center",
            borderColor: "#DEDEDE",
            height: 35,
          }}
        >
          {isMeasureType === "Duration" ? (
            <Text style={{ flex: 0.25, marginVertical: 8 }}>
              {new Date(item.amount * 1000).toISOString().slice(11, 19)}
            </Text>
          ) : (
            <Text style={{ flex: 0.25, marginVertical: 8 }}>
              {item.amount}
              <Text style={{ alignSelf: "center" }}>m³</Text>
            </Text>
          )}
        </View>
        <View
          style={{
            flex: 0.25,
            alignItems: "center",
            borderColor: "#DEDEDE",
            height: 35,
          }}
        >
          <IconCross
            name="circle-with-cross"
            color="red"
            size={30}
            onPress={() => deleteAddValveItems(item.valve.id, item.valve.name)}
          />
        </View>
      </View>
    );
  };

  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;
  return (
    <View style={styles.container}>
      <Modal
        onRequestClose={() => setIsVisible(false)}
        transparent={true}
        visible={isVisible}
      >
        <View
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            backgroundColor: "rgba(100,100,100, 0.5)",
          }}
        >
          <View
            style={
              isMobile
                ? {
                    backgroundColor: "#F8F8F8",
                    borderColor: "#eee",
                    borderRadius: 10,
                    borderWidth: 1,
                    margin: "auto",
                    padding: 30,
                    shadowOffset: {
                      width: 0,
                      height: 2,
                    },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                    elevation: 5,
                    width: "80%",
                  }
                : [styles.containeralt]
            }
          >
            <Text
              style={{
                alignSelf: "center",
                color: "#484848",
                fontSize: 14,
                fontWeight: "700",
              }}
            >
              Set Amount
            </Text>
            <FlatList
              data={valveDetails}
              numColumns={2}
              style={{ width: "100%" }}
              renderItem={({ item }) => {
                var finaldata: {
                  amount: any;
                  name: any;
                  order: number;
                  valve: { connect: { id: any } };
                }[] = [];
                return (
                  <Pressable
                    disabled={
                      programAmount
                        .map((itemss) => {
                          return itemss.name;
                        })
                        .includes(item.name)
                        ? true
                        : false
                    }
                    onPress={() => {
                      updatedata
                        ? 
                          ProgramAmountDetails.map((Fdata) => {
                            return finaldata.push({
                              amount: Fdata.amount,
                              name: Fdata.name,
                              order: 0,
                              valve: {
                                connect: {
                                  id: Fdata.bermad_valve_id,
                                },
                              },
                            });
                          })
                        : ProgramAmountDetails.map((Fdata) => {
                            const valveId =
                              Fdata.valve && Fdata.valve.connect
                                ? Fdata.valve.connect.id
                                : null;
                            return finaldata.push({
                              amount: Fdata.amount,
                              name: Fdata.name,
                              order: 0,
                              valve: {
                                connect: {
                                  id: valveId,
                                },
                              },
                            });
                          });
                      (OmegaDetails[mainindexmodal].ProgramsAmountData.push(
                        ...finaldata,
                      ),
                        setupdatedata(false));
                      setSelectedValve(item);
                      setValveSelected(item);
                    }}
                    style={
                      isMobile
                        ? {
                            borderWidth: 1,
                            width: "40%",
                            borderColor:
                              programAmount
                                .map((itemss) => {
                                  return itemss.name;
                                })
                                .includes(item.name) || item == ValveSelected
                                ? "#009DF0"
                                : "#707070",
                            margin: 10,
                            alignItems: "center",
                            backgroundColor:
                              programAmount
                                .map((itemss) => {
                                  return itemss.name;
                                })
                                .includes(item.name) || item == ValveSelected
                                ? "#F8F8F8"
                                : "white",
                            justifyContent: "space-between",
                          }
                        : {
                            borderWidth: 1,
                            width: "45%",
                            borderColor:
                              programAmount
                                .map((itemss) => {
                                  return itemss.name;
                                })
                                .includes(item.name) || item == ValveSelected
                                ? "#009DF0"
                                : "#707070",
                            margin: 10,
                            alignItems: "center",
                            backgroundColor:
                              programAmount
                                .map((itemss) => {
                                  return itemss.name;
                                })
                                .includes(item.name) || item == ValveSelected
                                ? "#F8F8F8"
                                : "white",
                            justifyContent: "space-between",
                          }
                    }
                  >
                    <Text
                      style={{
                        marginVertical: 10,
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      {item.name}
                    </Text>
                  </Pressable>
                );
              }}
            />

            <View
              style={{ width: "90%", alignSelf: "center", marginBottom: 10 }}
            >
              {measurementType == "Duration" || isMeasureType == "Duration" ? (
                <View
                  style={{
                    flexDirection: "row",
                    alignSelf: "center",
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{ flexDirection: "column", alignItems: "center" }}
                  >
                    <TouchableOpacity
                      onPress={() => timeHr < 23 && settimeHr(timeHr + 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-up"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>

                    <Text
                      style={{
                        borderWidth: 1,
                        margin: 5,
                        width: 40,
                        alignContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                        alignSelf: "center",
                        borderColor: "#707070",
                        borderRadius: 6,
                      }}
                    >
                      {timeHr < 10 ? `0${timeHr}` : timeHr}{" "}
                    </Text>

                    <TouchableOpacity
                      onPress={() => timeHr > 0 && settimeHr(timeHr - 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-down"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={{ marginHorizontal: 5 }}>:</Text>
                  <View
                    style={{ flexDirection: "column", alignItems: "center" }}
                  >
                    <TouchableOpacity
                      onPress={() => timemin < 59 && settimemin(timemin + 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-up"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>

                    <Text
                      style={{
                        borderWidth: 1,
                        margin: 5,
                        width: 40,
                        alignContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                        borderColor: "#707070",
                        borderRadius: 6,
                      }}
                    >
                      {timemin < 10 ? `0${timemin}` : timemin}
                    </Text>

                    <TouchableOpacity
                      onPress={() => timemin > 0 && settimemin(timemin - 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-down"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={{ marginHorizontal: 5 }}>:</Text>
                  <View
                    style={{ flexDirection: "column", alignItems: "center" }}
                  >
                    <TouchableOpacity
                      onPress={() => timesec < 59 && settimesec(timesec + 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-up"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>

                    <Text
                      style={{
                        borderWidth: 1,
                        margin: 5,
                        width: 40,
                        alignContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                        borderColor: "#707070",
                        borderRadius: 6,
                      }}
                    >
                      {timesec < 10 ? `0${timesec}` : timesec}
                    </Text>

                    <TouchableOpacity
                      onPress={() => timesec > 0 && settimesec(timesec - 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-down"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              ) : (
                <TextInput
                  style={styles.input}
                  placeholder="Enter Amount"
                  value={valveamount}
                  autoFocus={true}
                  onChangeText={(text) => setvalveamount(text)}
                />
              )}
            </View>
            {isAdd == true && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  marginHorizontal: 20,
                }}
              >
                <TouchableOpacity
                  style={styles.saveBtn}
                  onPress={() => {
                    setupdatedata(false);
                    (setIsVisible(false), setvalveid(ValveSelected.valve_id));
                    setvalveUniqueId(ValveSelected.id);
                    OmegaDetails[mainindexmodal].ProgramsAmountData.push({
                      amount: valveamount,
                      name: ValveSelected.name,
                      order: 0,
                      valve: {
                        connect: {
                          id: ValveSelected.valve_id,
                        },
                      },
                    });
                    setValveSelected({});
                  }}
                >
                  <Text style={styles.btnText}>Update</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.saveBtn}
                  onPress={() => {
                    (setupdatedata(false),
                      setIsVisible(false),
                      updatedata
                        ? ProgramAmountDetails.map((Fdata) => {
                            return finaldata.push({
                              amount: Fdata.amount,
                              name: Fdata.name,
                              order: 0,
                              valve: {
                                connect: {
                                  id: Fdata.bermad_valve_id,
                                },
                              },
                            });
                          })
                        : ProgramAmountDetails.map((Fdata) => {
                            return finaldata.push({
                              amount: Fdata.amount,
                              name: Fdata.name,
                              order: 0,
                              valve: {
                                connect: {
                                  id: Fdata.valve.connect.id,
                                },
                              },
                            });
                          }));
                    (OmegaDetails[mainindexmodal].ProgramsAmountData.push(
                      ...finaldata,
                    ),
                      setupdatedata(false));
                    (setSelectedValve(item), setValveSelected(item));
                  }}
                >
                  <Text style={styles.btnText}>Cancel</Text>
                </TouchableOpacity>
              </View>
            )}
            {isAdd == false && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  marginHorizontal: 20,
                }}
              >
                <TouchableOpacity
                  style={styles.saveBtn}
                >
                  <Text style={styles.btnText}>Update</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.saveBtn}
                  onPress={() => setIsVisible(false)}
                >
                  <Text style={styles.btnText}>Cancel</Text>
                </TouchableOpacity>
              </View>
            )}
          </View>
        </View>
      </Modal>
      <SuccessPopup
        visible={issuccessVisible}
        PopupMessage={PopupMessage}
        Responsestatus={responsestatus}
        onChange={() => setissuccessVisible(false)}
      />
      <Modal
        transparent={true}
        visible={isProgramLimit}
        onRequestClose={() => {}}
      >
        <View style={styles.containeralt}>
          <Text style={{ textAlign: "center" }}>
            <Icon color="#eed202" name="warning" size={20} /> Maximum limit of
            program creation is 8 only
          </Text>
          <TouchableOpacity
            onPress={() => {
              setIsProgramLimit(false);
            }}
            style={styles.okBtn}
          >
            <Text style={{ color: "white" }}>Okay</Text>
          </TouchableOpacity>
        </View>
      </Modal>

      <Modal
        onRequestClose={() => setValveIsVisible(false)}
        transparent={true}
        visible={ValveIsVisible}
      >
        <View
          style={
            isMobile
              ? {
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                  backgroundColor: "rgba(100,100,100, 0.5)",
                }
              : {
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                  backgroundColor: "rgba(100,100,100, 0.5)",
                }
          }
        >
          <View
            style={
              isMobile
                ? {
                    backgroundColor: "#F8F8F8",
                    borderColor: "#eee",
                    borderRadius: 10,
                    borderWidth: 1,
                    margin: "auto",
                    padding: 30,
                    shadowOffset: {
                      width: 0,
                      height: 2,
                    },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                    elevation: 5,
                    width: "80%",
                  }
                : [styles.containeralt]
            }
          >
            <TouchableOpacity
              style={{ alignSelf: "flex-end" }}
              onPress={() => setValveIsVisible(false)}
            >
              <IconCross
                name="circle-with-cross"
                size={20}
                color="#000"
                style={{ bottom: 5, top: 10 }}
              />
            </TouchableOpacity>

            <Text style={{ alignSelf: "center", fontWeight: "700" }}>
              Set Amount
            </Text>
            <FlatList
              data={valveDetails}
              numColumns={2}
              style={{ width: "100%" }}
              renderItem={({ item }) => {
                return (
                  <Pressable
                    disabled={
                      programAmount
                        .map((itemss) => {
                          return itemss.valve.name;
                        })
                        .includes(item.name)
                        ? true
                        : false
                    }
                    onPress={() => {
                      (setValveSelected(item), setSelectedValve(item));
                      setAddValveError("");
                    }}
                    style={
                      isMobile
                        ? {
                            borderWidth: 1,
                            width: "40%",
                            borderColor:
                              programAmount
                                .map((itemss) => {
                                  return itemss.valve.name;
                                })
                                .includes(item.name) || item == ValveSelected
                                ? "#009DF0"
                                : "#707070",
                            margin: 10,
                            alignItems: "center",
                            backgroundColor:
                              programAmount
                                .map((itemss) => {
                                  return itemss.valve.name;
                                })
                                .includes(item.name) || item == ValveSelected
                                ? "#F8F8F8"
                                : "white",
                            justifyContent: "space-between",
                          }
                        : {
                            borderWidth: 1,
                            width: "45%",
                            borderColor:
                              programAmount
                                .map((itemss) => {
                                  return itemss.valve.name;
                                })
                                .includes(item.name) || item == ValveSelected
                                ? "#009DF0"
                                : "#707070",
                            margin: 10,
                            alignItems: "center",
                            backgroundColor:
                              programAmount
                                .map((itemss) => {
                                  return itemss.valve.name;
                                })
                                .includes(item.name) || item == ValveSelected
                                ? "#F8F8F8"
                                : "white",
                            justifyContent: "space-between",
                          }
                    }
                  >
                    <Text
                      style={{
                        marginVertical: 10,
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      {item.name}
                    </Text>
                  </Pressable>
                );
              }}
            />

            <View
              style={{ width: "90%", alignSelf: "center", marginBottom: 10 }}
            >
              {isMeasureType == "Duration" ? (
                <View
                  style={{
                    flexDirection: "row",
                    alignSelf: "center",
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{ flexDirection: "column", alignItems: "center" }}
                  >
                    <TouchableOpacity
                      onPress={() => timeHr < 23 && settimeHr(timeHr + 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-up"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>

                    <Text
                      style={{
                        borderWidth: 1,
                        margin: 5,
                        width: 40,
                        alignContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                        alignSelf: "center",
                        borderColor: "#707070",
                        borderRadius: 6,
                      }}
                    >
                      {timeHr < 10 ? `0${timeHr}` : timeHr}{" "}
                    </Text>

                    <TouchableOpacity
                      onPress={() => timeHr > 0 && settimeHr(timeHr - 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-down"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={{ marginHorizontal: 5 }}>:</Text>
                  <View
                    style={{ flexDirection: "column", alignItems: "center" }}
                  >
                    <TouchableOpacity
                      onPress={() => timemin < 59 && settimemin(timemin + 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-up"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>

                    <Text
                      style={{
                        borderWidth: 1,
                        margin: 5,
                        width: 40,
                        alignContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                        borderColor: "#707070",
                        borderRadius: 6,
                      }}
                    >
                      {timemin < 10 ? `0${timemin}` : timemin}
                    </Text>

                    <TouchableOpacity
                      onPress={() => timemin > 0 && settimemin(timemin - 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-down"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={{ marginHorizontal: 5 }}>:</Text>
                  <View
                    style={{ flexDirection: "column", alignItems: "center" }}
                  >
                    <TouchableOpacity
                      onPress={() => timesec < 59 && settimesec(timesec + 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-up"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>

                    <Text
                      style={{
                        borderWidth: 1,
                        margin: 5,
                        width: 40,
                        alignContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                        borderColor: "#707070",
                        borderRadius: 6,
                      }}
                    >
                      {timesec < 10 ? `0${timesec}` : timesec}
                    </Text>

                    <TouchableOpacity
                      onPress={() => timemin > 0 && settimesec(timesec - 1)}
                    >
                      <Text style={{ margin: 5 }}>
                        <IconTimer
                          color="#767676"
                          name="chevron-thin-down"
                          size={20}
                        />
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              ) : (
                <TextInput
                  style={styles.input}
                  placeholder="Enter Amount"
                  value={valveamount}
                  autoFocus={true}
                  onChangeText={(text) => {
                    setvalveamount(text);
                    setAddValveError("");
                  }}
                />
              )}
            </View>
            {isAdd == true && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  marginHorizontal: 20,
                }}
              >
                <TouchableOpacity
                  style={styles.saveBtn}
                  onPress={() => {
                    if (!ValveSelected || !ValveSelected.valve_id) {
                      setValveIsVisible(false);

                      setTimeout(() => {
                        setresponsestatus("failed");
                        setPopupMessage("Please select valve");
                        setissuccessVisible(true);

                        setTimeout(() => {
                          setissuccessVisible(false);
                          setValveIsVisible(true);
                        }, 800);
                      }, 100);
                      settimeHr(0);
                      settimemin(0);
                      settimesec(0);
                      return;
                    }

                    setValveIsVisible(false);

                    setvalveid(ValveSelected.valve_id);
                    setvalveUniqueId(ValveSelected.id);

                    setAddValveItems((prev) => [
                      ...prev,
                      {
                        amount: valveamount,
                        valve: ValveSelected,
                      },
                    ]);

                    setSelectedValveItems((prevSelectedValveItems) => [
                      ...prevSelectedValveItems,
                      {
                        amount: valveamount,
                        id: ValveSelected.valve_id,
                      },
                    ]);

                    settimeHr(0);
                    settimemin(0);
                    settimesec(0);
                    setValveSelected({});
                    setSelectedValve();
                  }}
                >
                  <Text style={styles.btnText}>Save</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.saveBtn}
                  onPress={() => {
                    setValveIsVisible(false);
                    settimeHr(0);
                    settimemin(0);
                    settimesec(0);
                    setValveSelected({});
                    setSelectedValve();
                  }}
                >
                  <Text style={styles.btnText}>Cancel</Text>
                </TouchableOpacity>
              </View>
            )}
            {isAdd == false && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  marginHorizontal: 20,
                }}
              >
                <TouchableOpacity
                  style={styles.saveBtn}
                >
                  <Text style={styles.btnText}>Update</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.saveBtn}
                  onPress={() => setIsVisible(false)}
                >
                  <Text style={styles.btnText}>Cancel</Text>
                </TouchableOpacity>
              </View>
            )}
          </View>
        </View>
      </Modal>

      <View
        style={{
          flexDirection: "row",
          width: "100%",
          marginBottom: 10,
          marginTop: -50,
          alignItems: "center",
        }}
      >
        <View style={{ flex: 1, marginHorizontal: 10, marginTop: 10 }}>
          <View style={{ flexDirection: "row", width: "60%" }}>
            <Dropdown
              ref={dropdownRefOmega}
              style={
                isMobile
                  ? {
                      borderColor: "#c3c3c3",
                      width: "30%",
                      backgroundColor: "#fff",
                      borderWidth: 1,
                      borderRadius: 5,
                      height: 40,
                      padding: 10,
                      marginLeft: -15,
                    }
                  : {
                      flex: 0.6,
                      borderColor: "#c3c3c3",
                      width: "100%",
                      backgroundColor: "#fff",
                      borderWidth: 1,
                      borderRadius: 5,
                      height: 40,
                      padding: 10,
                    }
              }
              placeholderStyle={
                isMobile
                  ? {
                      fontSize: 12,
                      color: "black",
                    }
                  : {
                      fontSize: 16,
                      color: "black",
                    }
              }
              selectedTextStyle={styles.selectedTextStyle}
              inputSearchStyle={styles.inputSearchStyle}
              data={OmegaIdData}
              search
              maxHeight={300}
              labelField="device_name"
              valueField="device_name"
              placeholder={!OmegaIdName ? "Select Omega" : "...."}
              searchPlaceholder="Search"
              value={OmegaIdName != "" ? OmegaIdName : OmegaIdValue}
              onChange={(item) => {
                Keyboard.dismiss();
                setOmegaIdValue(item.device_name);
                setOmegaValueiD(item.id);
                setomegaid(item.omega_id);
                setisopen(false);
                getOmegaDetails(projectId, item.omega_id);
                getValveOmegaDetails(item.id);
                setOmegaError("");
                setrefreshflatlist(!refreshflatlist);
              }}
              renderItem={renderOmegaIdListItems}
            />
            <View style={{ marginRight: 5 }}>
              {isLoadingSync ? (
                <ActivityIndicator
                  color="#1DA1F2"
                  visible={isLoadingSync}
                  textContent={"Loading..."}
                  size={40}
                />
              ) : (
                <View style={{ width: 25, height: 25 }}>
                  <TouchableOpacity
                    style={{
                      backgroundColor: "red",
                      margin: 15,
                      marginBottom: 20,
                    }}
                    onPress={() => getProgramSync()}
                  >
                    <IconRefresh name="refresh" size={25} />
                  </TouchableOpacity>
                </View>
              )}
            </View>
          </View>
          <View>
            <Text
              style={
                isMobile
                  ? {
                      color: "red",
                      fontSize: 10,
                      fontWeight: "600",
                      width: "70%",
                      marginLeft: 0,
                      marginBottom: 10,
                    }
                  : styles.error_text
              }
            >
              {OmegaError}
            </Text>
          </View>
        </View>

        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  flexDirection: "row",
                  marginLeft: -300,
                  marginRight: 85,
                  marginTop: -40,
                }
              : {
                  alignItems: "center",
                  flexDirection: "row",
                  marginRight: 20,
                }
          }
        >
          <Icon color="#5afc4c" name="square" size={isMobile ? 12 : 20} />
          <Text
            style={
              isMobile
                ? {
                    color: "#747474",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: 12,
                    marginLeft: 3,
                  }
                : [styles.btnTextCancel, { marginLeft: 5 }]
            }
          >
            Running
          </Text>
        </View>
        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  flexDirection: "row",
                  marginLeft: -80,
                  marginRight: -10,
                  marginTop: -40,
                }
              : {
                  alignItems: "center",
                  flexDirection: "row",
                  marginRight: 20,
                }
          }
        >
          <Text
            style={
              isMobile
                ? {
                    color: "#747474",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: 12,
                    marginLeft: 3,
                  }
                : [styles.btnTextCancel, { marginLeft: 5 }]
            }
          >
            <Icon color="#BABABA" name="square" size={isMobile ? 12 : 20} />{" "}
            Closed
          </Text>
        </View>
        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  flexDirection: "row",
                  marginLeft: -110,
                  marginRight: 20,
                  marginTop: -10,
                }
              : {
                  alignItems: "center",
                  flexDirection: "row",
                  marginRight: 20,
                }
          }
        >
          <Text
            style={
              isMobile
                ? {
                    color: "#747474",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: 12,
                    marginLeft: 3,
                  }
                : [styles.btnTextCancel, { marginLeft: 5 }]
            }
          >
            <Icon color="#FFC400" name="square" size={isMobile ? 12 : 20} />{" "}
            Running with Alert
          </Text>
        </View>
        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  flexDirection: "row",
                  marginLeft: -140,
                  marginRight: 20,
                  marginTop: 20,
                }
              : {
                  alignItems: "center",
                  flexDirection: "row",
                  marginRight: 20,
                }
          }
        >
          <Text
            style={
              isMobile
                ? {
                    color: "#747474",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: 12,
                    marginLeft: 3,
                  }
                : [styles.btnTextCancel, { marginLeft: 5 }]
            }
          >
            <Icon color="#FF675A" name="square" size={isMobile ? 12 : 20} />{" "}
            Closed with Alert
          </Text>
        </View>
        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  flexDirection: "row",
                  marginLeft: -140,
                  marginRight: 20,
                  marginTop: 20,
                }
              : {
                  alignItems: "center",
                  flexDirection: "row",
                  marginRight: 20,
                }
          }
        >
          <Text
            style={
              isMobile
                ? {
                    color: "#747474",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: 12,
                    marginLeft: 3,
                  }
                : [styles.btnTextCancel, { marginLeft: 5 }]
            }
          >
            <Icon color="#000000" name="square" size={isMobile ? 12 : 20} />{" "}
            Disabled
          </Text>
        </View>
        {!isMobile && (
          <View
            style={{
              alignItems: "center",
              flexDirection: "row",
              marginRight: 10,
            }}
          >
            {OmegaDetails.length > 0 && (
              <View
                style={{
                  flexDirection: "row",
                  marginLeft: -5,
                  justifyContent: "flex-end",
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    backPress();
                  }}
                >
                  <Text style={{ marginHorizontal: 5 }}>
                    <IconArrow
                      color="#767676"
                      name="chevron-left"
                      size={isMobile ? 12 : 20}
                    />
                  </Text>
                </TouchableOpacity>
                <Text
                  style={{
                    paddingHorizontal: 5,
                    borderColor: "#707070",
                    borderRadius: 6,
                  }}
                >
                  {OmegaDetails.length} Programs{" "}
                </Text>

                <TouchableOpacity
                  onPress={() => {
                    nextPress();
                  }}
                >
                  <Text style={{ marginHorizontal: 5 }}>
                    <IconArrow
                      color="#767676"
                      name="chevron-right"
                      size={isMobile ? 12 : 20}
                    />
                  </Text>
                </TouchableOpacity>
              </View>
            )}
          </View>
        )}

        <View
          style={
            isMobile ? { alignItems: "flex-end" } : { alignItems: "flex-start" }
          }
        >
          <TouchableOpacity
            style={
              isMobile
                ? {
                    alignItems: "center",
                    backgroundColor: "#006EB9",
                    padding: 10,
                    marginLeft: -5,
                    height: 30,
                    borderWidth: 1,
                    borderRadius: 5,
                    borderColor: "#747474",
                    width: "80%",
                    paddingTop: 3,
                  }
                : styles.addDevice1
            }
            onPress={() => {
              OmegaDetails.length >= 8
                ? setIsProgramLimit(true)
                : OmegaIdValue || OmegaIdName
                  ? setisopen(true)
                  : setOmegaError("Please select Omega ");
            }}
          >
            <Text style={styles.btnText}>Add </Text>
          </TouchableOpacity>
        </View>
      </View>

      <View
        style={{
          flexDirection: "row",
          alignSelf: "flex-start",
          backgroundColor: "#fff",
          width: "100%",
          borderWidth: OmegaDetails.length > 0 ? 3 : 0,
          borderColor: "#EBEBEB",
          marginTop: -10,
        }}
      >
        {isLoading ? (
          <ActivityIndicator
            color="#1DA1F2"
            visible={isLoading}
            textContent={"Loading..."}
            size={40}
          />
        ) : (
          <MenuProvider style={styles.menuprovider}>
            {OmegaDetails.length > 0 && (
              <FlatList
                horizontal
                ref={flatListRef}
                data={OmegaDetails}
                extraData={refreshflatlist}
                renderItem={renderItemScedular}
                keyExtractor={(item) => item.index}

                style={{
                  flex: 1,
                  height: "100%",
                  width: isopen ? "100%" : "100%",
                }}
              />
            )}
            {OmegaDetails.length == 0 && (
              <View style={{ justifyContent: "center" }}>
                <Text
                  style={[styles.emptyListStyle, { alignSelf: "flex-start" }]}
                >
                  No Program Data Found{" "}
                </Text>
              </View>
            )}
          </MenuProvider>
        )}
        {isopen && (
          <View style={isMobile ? { width: "85%" } : { width: "23%" }}>
            <View
              style={{
                height: "5%",
                alignSelf: "flex-start",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <TextInput
                style={styles.input}
                placeholder="Program Name"
                value={newProjectName}
                onChangeText={(value) => {
                  setProjectName(value);
                  setprogNameError("");
                }}
              />
            </View>
            <Text style={[styles.error_text]}>{progNameError}</Text>

            <View
              style={{
                alignSelf: "flex-start",
                width: "100%",
                marginTop: 0,
                flexDirection: "row",
              }}
            >
              <View
                style={{
                  borderRightWidth: 1,
                  borderLeftWidth: 3,
                  borderLeftColor: "#dedede",
                  width: "100%",
                  borderRightColor: "#DEDEDE",
                }}
              >
                <View
                  style={{
                    marginTop: 10,
                    maxHeight: "10%",
                    marginHorizontal: 5,
                    flexDirection: "row",
                    marginBottom: -10,
                  }}
                >
                  <Text style={[{ flex: 0.85 }, styles.schedulHead]}>
                    Program Type
                  </Text>
                  <Dropdown
                    ref={dropdownRefPT}
                    style={{
                      borderColor: "#c3c3c3",
                      width: "35%",
                      borderWidth: 1,
                      borderRadius: 5,
                      height: 10,
                      padding: 10,
                    }}
                    search
                    data={ProgramTypeIdData}
                    maxHeight={300}
                    labelField="name"
                    valueField="name"
                    placeholder={
                      programTypeIdValue == ""
                        ? "select"
                        : programTypeIdValue.charAt(0).toUpperCase() +
                          programTypeIdValue.slice(1).toLowerCase()
                    }
                    searchPlaceholder="Search"
                    value={
                      programTypeIdValue.charAt(0).toUpperCase() +
                      programTypeIdValue.slice(1).toLowerCase()
                    }
                    onChange={(item) => {
                      setprogramTypeIdValue(item.name);
                      setprogramTypeValueiD(item.id);

                      setOmegaError("");
                      setrefreshflatlist(!refreshflatlist);
                    }}
                    renderItem={renderProgramType}
                  />
                </View>
                <Text style={[styles.error_text]}>{programTypeError}</Text>

                {programTypeIdValue == "CYCLIC" ? (
                  <View style={{ maxHeight: "20%" }}>
                    <View
                      style={{
                        flex: 1,
                        alignItems: "center",
                        marginHorizontal: 5,
                        flexDirection: "row",
                        marginBottom: 10,
                        marginTop: 10,
                      }}
                    >
                      <Text style={[{ flex: 0.95 }, styles.schedulHead]}>
                        Start Date
                      </Text>
                      <View>
                        <Text
                          style={{
                            borderColor: "gray",
                            borderWidth: 1,
                            textAlign: "center",
                            paddingHorizontal: 7,
                            borderRadius: 5,
                            marginRight: 20,
                            padding: 2,
                          }}
                          onPress={() => setOpen(true)}
                        >
                          {date
                            ? moment(date).format("DD/MM/YYYY")
                            : "Select Date "}
                        </Text>
                        <DatePickerModal
                          locale="en"
                          mode="single"
                          visible={open}
                          onDismiss={onDismissSingle}
                          date={date}
                          onConfirm={onConfirmNewDate}
                          validRange={{
                            endDate: new Date(), 
                          }}
                          label="Select date" 
                          closeIcon="close"
                          calendarIcon="calendar"
                        />
                      </View>
                    </View>
                    <View
                      style={{
                        flex: 1,
                        alignItems: "center",
                        marginHorizontal: 5,
                        flexDirection: "row",
                        marginBottom: 5,
                      }}
                    >
                      <Text style={[{ flex: 0.95 }, styles.schedulHead]}>
                        Day's Interval
                      </Text>
                      <View style={{ flexDirection: "row", width: "37%" }}>
                        <TouchableOpacity
                          onPress={() => count > 0 && setcount(count - 1)}
                        >
                          <Text style={{ margin: 5 }}>
                            <IconPlusMinus
                              color="#767676"
                              name="minuscircleo"
                              size={20}
                            />
                          </Text>
                        </TouchableOpacity>

                        <Text
                          style={{
                            borderWidth: 1,
                            padding: 5,
                            marginHorizontal: 5,
                            borderColor: "#707070",
                            borderRadius: 6,
                          }}
                        >
                          {count}{" "}
                        </Text>

                        <TouchableOpacity
                          onPress={() => count < 15 && setcount(count + 1)}
                        >
                          <Text style={{ margin: 5 }}>
                            <IconPlusMinus
                              color="#767676"
                              name="pluscircleo"
                              size={20}
                            />
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                ) : (
                  <View
                    style={{
                      alignItems: "center",
                      marginHorizontal: 5,
                      flexDirection: "row",
                      marginVertical: 10,
                      marginBottom: -10,
                      marginTop: 10,
                    }}
                  >
                    <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                      Program Days
                    </Text>
                    <MultiSelect
                      hideTags
                      fixedHeight={true}
                      items={daysData}
                      uniqueKey="id"
                      onSelectedItemsChange={onSelectedAddItemsChange}
                      selectedItems={AddselectedDays}
                      selectText="Select days"
                      searchInputPlaceholderText="Search"
                      tagRemoveIconColor="#CCC"
                      tagBorderColor="#CCC"
                      tagTextColor="#CCC"
                      selectedItemTextColor="#009DF0"
                      selectedItemIconColor="#CCC"
                      itemTextColor="#000"
                      displayKey="name"
                      submitButtonColor="#fff"
                      submitButtonText="Submit"
                      searchInputStyle={
                        isMobile
                          ? {
                              height: 40,
                              fontSize: 16,
                              outlineStyle: "none",
                              width: 100,
                            }
                          : styles.inputSearchStyle
                      }
                      styleDropdownMenu={{ backgroundColor: "#fff" }}
                    />
                  </View>
                )}
                <Text style={[styles.error_text, { marginTop: 8 }]}>
                  {progDaysError}
                </Text>
                <View
                  style={{
                    alignItems: "flex-start",
                    marginHorizontal: 5,
                    marginTop: 5,
                    flexDirection: "row",
                  }}
                >
                  <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                    Program Start
                  </Text>
                  <Dropdown
                    ref={dropdownRefIS}
                    style={{
                      borderColor: "#c3c3c3",
                      width: "40%",
                      borderWidth: 1,
                      borderRadius: 5,
                      alignItems: "center",
                      height: 20,
                      padding: 10,
                    }}
                    inputSearchStyle={styles.inputSearchStyle}
                    search
                    data={IrrigationStartData}
                    maxHeight={300}
                    labelField="name"
                    valueField="name"
                    placeholder={
                      IrrigationNewStartSelect
                        ? IrrigationNewStartSelect
                        : "Select"
                    }
                    searchPlaceholder="Search"
                    value={IrrigationNewStartSelect}
                    onChange={(item) => {
                      setIrrigationNewStartSelect(item.name);
                      setIrrigationNewStartSelectId(item.id);
                    }}
                    renderItem={renderIrrigation}
                  />
                </View>
                <Text style={[styles.error_text]}>{programTimeError}</Text>

                {IrrigationNewStartSelect === "Hours" && (
                  <>
                    <View
                      style={{
                        alignItems: "flex-start",
                        marginHorizontal: 5,
                        flexDirection: "row",
                        marginTop: 10,
                      }}
                    >
                      <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                        Program Start Times
                      </Text>
                      <Pressable
                        disabled={newprgStartData1.length <= 3 ? false : true}
                        onPress={() => {
                          setprogramStartTimeVisible(true);
                        }}
                        style={{
                          flexDirection: "row",
                          borderWidth: 1,
                          marginRight: 5,
                          borderColor: "#707070",
                          borderRadius: 5,
                          backgroundColor: "#EBEBEB",
                          padding: 5,
                          alignItems: "center",
                          alignSelf: "flex-end",
                          marginVertical: 10,
                          marginTop: -5,
                        }}
                      >
                        <Text
                          style={
                            prgStartData.length <= 3
                              ? styles.valvebtnText
                              : { fontWeight: "400", color: "#CCC" }
                          }
                        >
                          Add start times
                        </Text>
                      </Pressable>

                      <TimePickerModal
                        visible={programStartTimeVisible}
                        onDismiss={onDismissProgramStartTime}
                        onConfirm={onConfirmNewProgramStartTime}
                        
                        data={programStartTime}
                        hours={0o0} 
                        minutes={0o0} 
                        locale="de"
                       
                      />
                    </View>

                    {newprgStartData1.length > 0 &&
                      newprgStartData1 != undefined && (
                        <FlatList
                         
                          style={{ width: "60%", alignSelf: "center" }}
                          contentContainerStyle={{ height: 90 }}
                          data={newprgStartData1}
                          
                          renderItem={(item, index) =>
                            renderProgramAddStartTimeItems(item, index)
                          }
                          keyExtractor={(item, index) => item.index}
                        />
                      )}
                  </>
                )}
                {IrrigationNewStartSelect === "Cyclic" && (
                  <View>
                    <View
                      style={{
                        flex: 1,
                        marginHorizontal: 5,
                        flexDirection: "row",
                      }}
                    >
                      <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                        Program Start time
                      </Text>
                      <View
                        style={{
                          borderWidth: 1,
                          borderColor: "grey",
                          alignItems: "center",
                          borderRadius: 5,
                          width: "40%",
                        }}
                      >
                        <Text
                          style={{ margin: 5 }}
                          onPress={() => setTimeStartVisible(true)}
                        >
                          {timeStart
                            ? moment(timeStart).format("HH:mm:ss")
                            : "hh:mm:ss "}
                        </Text>

                        <TimePickerModal
                          visible={timeStartVisible}
                          onDismiss={onDismissStartTime}
                          onConfirm={onnewConfirmStartTime}
                          
                          data={timeStart}
                          hours={12} 
                          minutes={14} 
                          locale="de"
                          
                        />
                      </View>
                    </View>
                    <Text style={[styles.error_text]}>
                      {programStrtTimeError}
                    </Text>
                    <View
                      style={{
                        flex: 1,
                        alignItems: "center",
                        marginHorizontal: 5,
                        flexDirection: "row",
                      }}
                    >
                      <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                        Program End Time
                      </Text>
                      <View
                        style={{
                          borderWidth: 1,
                          borderColor: "grey",
                          borderRadius: 5,
                          alignItems: "center",
                          width: "40%",
                        }}
                      >
                        <Text
                          style={{ margin: 5 }}
                          onPress={() => setTimeVisible(true)}
                        >
                          {times
                            ? moment(times).format("HH:mm:ss")
                            : "hh:mm:ss "}
                        </Text>

                        <TimePickerModal
                          visible={timeVisible}
                          onDismiss={onDismissTime}
                          onConfirm={onConfirmNewEndTime}
                          
                          data={times}
                          hours={12} 
                          minutes={14} 
                          locale="de"
                          
                        />
                      </View>
                    </View>
                    <Text style={[styles.error_text]}>
                      {programEndTimeError}
                    </Text>
                    <View
                      style={{
                        flex: 1,
                        alignItems: "center",
                        marginHorizontal: 5,
                        flexDirection: "row",
                      }}
                    >
                      <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                        Hours Interval
                      </Text>
                      <View
                        style={{
                          borderWidth: 1,
                          borderColor: "grey",
                          borderRadius: 5,
                          alignItems: "center",
                          width: "40%",
                        }}
                      >
                        <Text
                          style={{ margin: 5 }}
                          onPress={() => setTimeHIVisible(true)}
                        >
                          {timeHoursInterval
                            ? moment(timeHoursInterval).format("HH:mm:ss")
                            : "hh:mm:ss "}
                        </Text>
                        <Text style={[styles.error_text]}>
                          {programHoursError}
                        </Text>

                        <TimePickerModal
                          visible={timeHIVisible}
                          onDismiss={onDismissHITime}
                          onConfirm={onConfirmNewHITime}
                          
                          data={timeHoursInterval}
                          hours={12} 
                          minutes={14} 
                          locale="de"
                          
                        />
                      </View>
                    </View>
                    <Text style={[styles.error_text]}>
                      {programEndTimeError}
                    </Text>
                  </View>
                )}

                <View
                  style={{
                    marginTop: 10,
                    height: 0.5,
                    width: "95%",
                    alignSelf: "center",
                    backgroundColor: "grey",
                  }}
                />
                <View
                  style={{
                    alignItems: "center",
                    marginHorizontal: 5,
                    flexDirection: "row",
                    marginTop: 10,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      flex: 1,
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={
                        isMobile
                          ? {
                              color: "#0089D1",
                              textTransform: "capitalize",
                              fontWeight: "700",
                              marginTop: -40,
                            }
                          : [{ flex: 0.7 }, styles.schedulHead]
                      }
                    >
                      Measurement Type
                    </Text>
                    <View
                      style={
                        isMobile
                          ? {
                              flexDirection: "row",
                              flex: 0.75,
                              alignItems: "center",
                              marginLeft: -90,
                              marginTop: 20,
                            }
                          : {
                              flexDirection: "row",
                              flex: 0.75,
                              alignItems: "center",
                              marginLeft: -10,
                            }
                      }
                    >
                      <RadioButton
                        uncheckedColor={"#F0F0F0"}
                        color={"#707070"}
                        value="Duration"
                        status={
                          isMeasureType == "Duration" ? "checked" : "unchecked"
                        }
                        onPress={() => setMeasureType("Duration")}
                      />
                      <Text style={{ fontSize: 12, color: "#707070" }}>
                        Duration
                      </Text>
                      <RadioButton
                        color={"#707070"}
                        uncheckedColor={"#F0F0F0"}
                        value="Quantity"
                        status={
                          isMeasureType == "Quantity" ? "checked" : "unchecked"
                        }
                        onPress={() => setMeasureType("Quantity")}
                      />
                      <Text style={{ fontSize: 12, color: "#707070" }}>
                        Quantity
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={{ marginHorizontal: 5, marginTop: 10 }}>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={[{ flex: 1 }, styles.schedulHead]}>
                      Valve Program in Sequence
                    </Text>
                    <Pressable
                      onPress={() => {
                        (isvalveCreatable(), setvalveamount(""));
                      }}
                      style={{
                        flexDirection: "row",
                        borderWidth: 1,
                        marginRight: 5,
                        borderColor: "#707070",
                        borderRadius: 5,
                        backgroundColor:
                          AddValveItems.length == 1 ? "#EBEBEB" : "#CCC",
                        padding: 5,
                        alignItems: "center",
                        alignSelf: "flex-end",
                        marginVertical: 10,
                        marginTop: -5,
                      }}
                    >
                      <Icon
                        color="#747474"
                        name="plus"
                        size={15}
                        style={{ marginRight: 4 }}
                      />
                      <Text style={styles.valvebtnText}>Add Valve</Text>
                    </Pressable>
                  </View>
                  <FlatList
                    data={AddValveItems}
                    renderItem={renderAddValveItems}
                    keyExtractor={(item, index) => item.index}
                  />
                  <Text style={[styles.error_text]}>{AddValveError}</Text>
                </View>
              </View>
            </View>

            <View
              style={{
                marginTop: 10,
                height: 0.5,
                width: "100%",
                alignSelf: "center",
                backgroundColor: "grey",
              }}
            />
            <View
              style={{
                height: "35%",
                alignSelf: "flex-start",
                marginTop: 0,
                width: "100%",
              }}
            >
              <View
                style={{
                  width: "100%",
                  borderRightWidth: 3,
                  borderLeftWidth: 3,
                  borderBottomWidth: 1,
                  borderBottomColor: "#DEDEDE",
                  borderRightColor: "#DEDEDE",
                  borderLeftColor: "#DEDEDE",
                }}
              >
                <View
                  style={{
                    flex: 1,
                    alignItems: "center",
                    marginHorizontal: 5,
                    flexDirection: "row",
                    marginVertical: 5,
                  }}
                >
                  <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                    Program Action
                  </Text>
                  <Dropdown
                    style={{
                      borderColor: "#c3c3c3",
                      width: "40%",
                      borderWidth: 1,
                      borderRadius: 5,
                      height: 20,
                      padding: 10,
                    }}
                    placeholderStyle={styles.placeholderStyle}
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    search
                    data={programActions}
                    maxHeight={300}
                    labelField="name"
                    valueField="name"
                    placeholder={
                      programActionsSelect
                        ? programActionsSelect
                        : "select action"
                    }
                    searchPlaceholder="Search"
                    value={programActionsSelect}
                    onChange={(item) => {
                      setprogramActionsSelect(item.name);
                      setprogramActionsSelectId(item.id);
                    }}
                    renderItem={renderProgAction}
                  />
                </View>

                {programActionsSelect === "None" ? null : (
                  <>
                    <View style={{ flex: 1, marginHorizontal: 5 }}>
                      <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                        Device
                      </Text>
                      <Dropdown
                        ref={dropdownRefDI}
                        style={{
                          borderColor: "#c3c3c3",
                          width: "95%",
                          marginTop: 5,
                          borderWidth: 1,
                          borderRadius: 5,
                          height: 30,
                          padding: 10,
                        }}
                        data={deviceNameData}
                        search
                        maxHeight={300}
                        labelField="device_name"
                        valueField="device_name"
                        placeholder={!isFocus ? "Select" : "...."}
                        searchPlaceholder="Search"
                        value={OmegaAddIdValue}
                        onChange={(item) => {
                          setOmegaAddIdValue(item.device_name);
                          setOmegaAddValueiD(item.id);
                          getSensorOmegaDetails(item.id);
                          setOmegaError("");
                          setrefreshflatlist(!refreshflatlist);
                        }}
                        renderItem={renderAddOmegaIdListItems}
                      />
                    </View>
                    <View
                      style={{ flex: 1, marginHorizontal: 5, marginTop: 20 }}
                    >
                      <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                        Sensor name
                      </Text>
                      <Dropdown
                        ref={dropdownRefST}
                        style={{
                          borderColor: "#c3c3c3",
                          width: "95%",
                          borderWidth: 1,
                          borderRadius: 5,
                          marginTop: 5,
                          height: 30,
                          padding: 10,
                        }}
                        data={sensorTypeDetails}
                        search
                        maxHeight={300}
                        labelField="name"
                        searchPlaceholder
                        valueField="name"
                        placeholder={!isFocus ? "select " : "...."}
                        searchPlaceholder="Search"
                        value={SensorIdValue}
                        onChange={(item) => {
                          setSensorIdValue(item.name);
                          setSensorValueiD(item.id);
                          setSensorvalueType(item.type);
                          setrefreshflatlist(!refreshflatlist);
                        }}
                        renderItem={renderSensorListItems}
                      />
                    </View>
                    <View
                      style={{ flex: 1, marginHorizontal: 5, marginTop: 15 }}
                    >
                      <Text style={[{ flex: 0.9 }, styles.schedulHead]}>
                        Value
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          borderRadius: 5,
                          marginTop: 5,
                          width: "95%",
                          borderColor: "#707070",
                        }}
                      >
                        {SensorvalueType == 2 ? (
                          <View
                            style={{
                              height: 30,
                              width: "100%",
                              marginHorizontal: 2,
                            }}
                          >
                            <TextInput value=""></TextInput>
                          </View>
                        ) : (
                          <Dropdown
                            ref={dropdownRefVS}
                            style={{
                              borderColor: "#c3c3c3",
                              width: "100%",
                              borderWidth: 1,
                              borderRadius: 5,
                              height: 20,
                              padding: 10,
                            }}
                            search
                            data={sensorStatus}
                            maxHeight={300}
                            labelField="name"
                            valueField="id"
                            placeholder={"Status"}
                            searchPlaceholder="Search"
                            value={sensorStatusIdValue}
                            onChange={(item) => {
                              setSensorStatusIdValue(item.name);
                              setSensorStatusiD(item.id);
                              setrefreshflatlist(!refreshflatlist);
                            }}
                            renderItem={renderSensorType}
                          />
                        )}
                      </View>
                    </View>
                  </>
                )}
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginVertical: 15,
                    width: "100%",
                  }}
                >
                  <TouchableOpacity
                    style={styles.cancleDevice}
                    onPress={() => {
                      setisopen(false);
                      setrefresh(false);
                      setprogramTypeIdValue("");
                      setprogramTypeValueiD("");
                      setAddSelectedDays([]);
                      setIrrigationNewStartSelect("");
                      setIrrigationNewStartSelectId("");
                      setTimeStart("");
                      setTimes("");
                      setTimeHoursInterval("");
                      setMeasureType("Duration");
                      setAddValveItems([]);
                      setprogramActionsSelect("None");
                      setprogramActionsSelectId("");
                      setValveSelected({});
                      setSelectedValve();
                      setcount(0);
                      setCounter();
                      setprogramStartTime("");
                      setDate(undefined);
                      setNewPrgStartData1([]);
                      setPrgStartData([]);
                      setOmegaAddIdValue(null);
                      setOmegaAddValueiD(null);
                      setSensorIdValue(null);
                      setSensorValueiD("");
                      setSensorvalueType("");
                      setSensorStatusIdValue(null);
                      setSensorStatusiD("");

                    }}
                  >
                    <Text style={styles.btnTextCancel}>Cancel</Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={[styles.addDevice, { width: "48%" }]}
                    onPress={() => {
                      CheckEnteredData();
                    }}
                  >
                    <Text style={styles.btnText}>Save</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
        )}
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      alignItems: "center",
      justifyContent: "center",
      padding: 10,
    },
    menuCon: {
      alignSelf: "flex-end",
      justifyContent: "flex-end",
      backgroundColor: "#ecf0f1",
    },
    input: {
      borderColor: "gray",
      width: "100%",
      borderWidth: 1,
      borderRadius: 10,
      padding: 10,
    },
    tableHeader: {
      color: "#000",
      fontSize: 14,
      /* FontFamily: 'Muli' ,*/
      fontWeight: "700",
    },
    tableHead: {
      fontSize: 14,
      /* FontFamily: 'Muli' ,*/
      fontWeight: "400",
      color: "#000000",
    },
    contanerSwitch: {
      backgroundColor: "white",
      borderColor: "#eee",
      borderRadius: 5,
      alignSelf: "center",
      borderWidth: 1,
      height: "25%",
      margin: "auto",
      padding: 10,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
      width: "30%",
    },
    clickBtn: {
      backgroundColor: "#0089D1",
      padding: 10,
      borderWidth: 1,
      borderColor: "#006EB9",
      width: "90%",
      marginRight: 20,
      alignItems: "center",
    },
    error_text: {
      color: "red",
      fontSize: 14,
      fontWeight: "600",
      width: "70%",
      marginLeft: 0,
      marginBottom: 10,
    },
    saveBtn: {
      alignItems: "center",
      backgroundColor: "#006EB9",
      padding: 10,
      borderWidth: 1,
      borderColor: "#006EB9",
      width: "50%",
      marginRight: 10,
    },
    okBtn: {
      alignItems: "center",
      justifyContent: "center",
      alignSelf: "center",
      backgroundColor: "#006EB9",
      marginTop: 20,
      padding: 10,
      borderWidth: 1,
      borderColor: "#006EB9",
      width: "50%",
    },
    addValvebtn: {
      alignItems: "center",
      backgroundColor: "#EBEBEB",
      padding: 10,
      borderWidth: 1,
      borderColor: "#EBEBEB",
      width: "20%",
      marginRight: 10,
    },
    addDevice: {
      alignItems: "center",
      backgroundColor: "#006EB9",
      padding: 10,
      marginLeft: 5,
      height: 40,
      borderWidth: 1,
      borderRadius: 5,
      borderColor: "#747474",
      width: "93%",
      marginRight: 20,

    },
    addDevice1: {
      alignItems: "center",
      backgroundColor: "#006EB9",
      padding: 10,
      marginLeft: -5,
      height: 40,
      borderWidth: 1,
      borderRadius: 5,
      borderColor: "#747474",
      width: "93%",
      marginRight: 40,

    },
    cancleDevice: {
      alignItems: "center",
      backgroundColor: "#fff",
      padding: 10,
      height: 40,
      borderRadius: 5,
      borderWidth: 1,
      borderColor: "#747474",
      width: "48%",
    },
    title: {
      fontSize: 20,
      fontWeight: "bold",
    },
    valvebtnText: {
      color: "#747474",
      fontWeight: "600",
    },
    btnText: {
      color: "#fff",
      fontWeight: "600",
    },
    btnTextCancel: {
      color: "#747474",
      fontWeight: "600",
      textAlign: "center",
    },
    menuprovider: {
      flex: 1,
      width: "100%",
      backgroundColor: "#fff",
      justifyContent: "center",
      flexDirection: "column",
    },
    containeralt: {
      backgroundColor: "#F8F8F8",
      borderColor: "#eee",
      borderRadius: 10,
      borderWidth: 1,
      margin: "auto",
      padding: 30,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
      width: "30%",
    },
    card: {
      width: "100%",
      flex: 1,
      marginVertical: 10,
    },
    shadowProp: {
      shadowColor: "#171717",
      shadowOffset: { width: -2, height: 4 },
      shadowOpacity: 0.2,
      shadowRadius: 25,
    },
    link: {
      marginTop: 15,
      paddingVertical: 15,
    },
    linkText: {
      fontSize: 14,
      color: "#2e78b7",
    },
    textInputStyle: {
      height: 40,
      borderWidth: 2,
      paddingLeft: 10,
      margin: 5,
      opacity: 2,
      borderRadius: 5,
      borderColor: "#319ef0",
      backgroundColor: "#FFFFFF",
      width: "40%",
      color: "#000",
      fontWeight: "600",
    },
    counterText: {
      borderWidth: 1,
      padding: 15,
      borderColor: "#707070",
      borderRadius: 6,
    },
    leftMenu: { color: "#000", margin: 10, fontWeight: "500", fontSize: 16 },
    schedulHead: {
      color: "#0089D1",
      textTransform: "capitalize",
      fontWeight: "700",
    },
    emptyListStyle: {
      padding: 10,
      fontSize: 10,
      textAlign: "center",
    },

    dropdown: {
      borderColor: "#c3c3c3",
      width: "100%",
      borderWidth: 1,
      borderRadius: 2,
      height: 40,

      padding: 10,
      marginTop: 5,
      marginBottom: 5,
      
    },

    icon: {
      marginRight: 5,
    },
    item: {
      padding: 17,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    textItem: {
      flex: 1,
      fontSize: 16,
    },
    placeholderStyle: {
      fontSize: 12,
      alignSelf: "center",
    },
    selectedTextStyle: {
      fontSize: 16,
      alignSelf: "center",
    },
    
    iconStyle: {
      width: 0,
      height: 0,
    },
    inputSearchStyle: {
      height: 40,
      fontSize: 16,
      outlineStyle: "none",
    },
    lableText: {
      color: "#484848",
      fontWeight: "700",
      marginTop: 18,
    },
    labelTitleTBD: {
      color: "#707070",
      padding: 10,
      fontSize: 20,
    },
    labelTitle: {
      padding: 15,
      color: "#0089D1",
      fontWeight: "600",
      textTransform: "Capitalize",
    },
  },
  {
    [DEVICE_SIZES.XL]: {
      container: {
        alignItems: "center",
        justifyContent: "center",
        padding: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        alignItems: "center",
        justifyContent: "center",
        padding: 10,
      },
    },
  },
);

const optionsStyles = {
  optionsContainer: {
    width: "100px",
    padding: 5,
  },
  optionsWrapper: {
  },
  optionWrapper: {
    margin: 5,
  },
  optionTouchable: {
    activeOpacity: 70,
  },
  optionText: {
  },
};
